import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import { CircularProgress, Grid, Divider, DialogTitle, DialogContentText, Button, Dialog, DialogActions, DialogContent, TextField } from '@material-ui/core';
import ReactTooltip from 'react-tooltip';
//Iconos
//"/assets/dist/svg/main.svg#info"
import 'office-ui-fabric-react/dist/css/fabric.css'
import ErrorOutlineRounded from '@material-ui/icons/ErrorOutlineRounded'
import { ComboBox, HoverCard, KeyCodes, setFocusVisibility } from 'office-ui-fabric-react';
import Alert from '@material-ui/lab/Alert/Alert';
import d1 from '../../../../assets/dist/svg/main.svg';

import { initializeIcons } from '@uifabric/icons';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
import parse from 'html-react-parser';
import { con } from "../../../../application/entity/Rutas";

import {
    InsertarClienteMandatoPagoLogic, ObtenerClienteMandatoPagoLogic, EliminarClienteMandatoPagoLogic, ObtieneBeneficioComplementarioLogic,
    ObtenerOCLogic, ObtieneMesesPagoLogic, ObtieneCuotasPagoLogic, ObtenerFecha1erPagoLogic,
    ObtieneSaldosPendientesPorPagarLogic,
    GuardarFormaPagoLogic
} from '../../../view-model/Arancel/Arancel.logic';
import { ObtieneEtapasLogic, ObtieneSiguienteEtapaLogic, ObtieneCondicionesLogic, ObtieneBeneficioAutomaticoLogic, ObtieneBeneficioAutomaticoPorRutLogic } from '../../../view-model/Inicio/PostulacionesEstudiante.logic';
import { ObtieneParametrosLogic, ObtieneDiasLogic, ObtenerMonedasLogic, ObtenerPariedadLogic, ObtieneProcesoActualLogic, ObtieneParametrosPago, ObtieneParametrosBoolLogic } from '../../../view-model/Parametros/Parametros.logic';
import { ObtieneDocumentoPorAlumnoLogic, ObtieneDatosFacturacionLogic, GrabarFacturacionLogic, GetFacturacionInfoMatriculaLogic, Del_FacturacionInfoMatriculaLogic } from '../../../view-model/Facturacion/Facturacion.logic';
import IViewEtapas from '../../../view-interfaces/IViewEtapas';
import IViewCombo from '../../../view-interfaces/IViewCombo'
import IViewFormaPagoMulti from '../../../view-interfaces/IViewFormaPagoMulti';
import IViewParametros from '../../../../presentation/view-interfaces/IViewParametros';
import IViewClienteMandato from '../../../../presentation/view-interfaces/IViewClienteMandato';
import IViewMatricula from "../../../../presentation/view-interfaces/IViewMatricula";
import IViewArancel from "../../../../presentation/view-interfaces/IViewArancel";
import IViewCAE from "../../../../presentation/view-interfaces/IViewCAE";
import BeneficioComplementario from '../../../view-model/Modals/BeneficioComplementario';

import { UpdateEtapaProcesoLogic } from '../../../view-model/EtapasProceso/EtapasProceso.logic';
import { ObtieneTieneTransferenciaLogic } from '../../../view-model/Transferencia/transferencia.logic'
import { ObtieneDatosPersonalesLogic } from '../../../view-model/DatosPersonales/DatosPersonales.logic';
import { ObtieneTieneFirmaContratoLogic } from '../../../view-model/Contrato/Contrato.logic';
import { EnvioCorreoDeclaracionLogic } from '../../../view-model/Matricula/Matricula.logic';
import { ObtenerDatosAlumnoLogic } from '../../../view-model/PACPAT/PacPat.logic';

import { baseCSS } from 'react-select/src/components/indicators';
import '../SeleccionFormaPago/style.css'
import { emptyString } from 'react-select/src/utils';
import { Autocomplete } from '@material-ui/lab';
import toUpperCamelCase from '../../../view-model/Funciones/toUpperCamelCase';
import { ObtieneComunaLogic, ObtieneComunaHomologaLogic } from '../../../view-model/Combos/Combos.logic';

import IViewComunas from '../../../view-interfaces/IViewComunas';
import IViewComunasAuto from '../../../view-interfaces/IViewComunasAuto';
import DetalleMontoAranceles from '../../../../Components/FormaPago/DetalleMontoAranceles'
import IViewDetalleAranceles from '../../../view-interfaces/IViewDetalleAranceles';
import IViewSaldosPendientes from '../../../view-interfaces/IViewSaldosPendientes';
import IViewParametrosMatricula from '../../../view-interfaces/IViewParametrosMatricula';
import MensajeToken from '../../../../Components/MensajeToken/MensajeToken';

type Props = {
    onClickContinuar: any,
    formaPago: any,
    formaPago2: any;
    DatosAlumno: any;
    codigoNegocio: number;
    listaComunas: IViewComunasAuto[];
}
export const FormaPago: React.FC<Props> = (
    {
        onClickContinuar,
        formaPago,
        formaPago2,
        DatosAlumno,
        codigoNegocio,
        listaComunas
    }) => {
    initializeIcons();
    const history = useHistory();
    const location = useLocation();

    const [codNegocio, setCodNegocio] = useState(0);
    const [idProcesoPostulante, setIdProcesoPostulante] = useState(0);

    const [matriculaDetalle, setMatriculaDetalle] = useState<IViewDetalleAranceles | undefined>(undefined);
    const [arancelDetalle, setArancelDetalle] = useState<IViewDetalleAranceles | undefined>(undefined);

    const [totalMatriculaSaldoFinalCLP, setTotalMatriculaSaldoFinalCLP] = useState(9999);
    const [totalarancelSaldoFinalCLP, setTotalarancelSaldoFinalCLP] = useState(9999);
    const [totalMatriculaUF, setTotalMatriculaUF] = useState(0);
    const [totalArancelUF, setTotalArancelUF] = useState(0);

    const listaP: Array<IViewParametros> = [];
    const [listParamsArancel, setlistParamsArancel] = useState(listaP);
    const [listDiasMatricula, setlistDiasMatricula] = useState([]);
    const [listDiasArancel, setlistDiasArancel] = useState([]);
    const [listParamsMatricula, setlistParamsMatricula] = useState(listaP);

    const [combParamsArancel, setcombParamsArancel] = useState([]);
    const [combParamsMatricula, setcombParamsMatricula] = useState([]);

    const [combMesesMatricula, setcombMesesMatricula] = useState([]);
    const [combMesesArancel, setcombMesesArancel] = useState([]);

    const listaFP: Array<IViewFormaPagoMulti> = [];
    const [listFormaPagoArancel, setlistFormaPagoArancel] = useState(listaFP);
    const [listFormaPagoMatricula, setlistFormaPagoMatricula] = useState(listaFP);

    const [cargandoMultiArancel, setCargandoMultiArancel] = useState(false);
    const [cargandoMultiMatricula, setCargandoMultiMatricula] = useState(false);

    const [cantDiasArancel, setCantDiasArancel] = useState(0);
    const [cantDiasMatricula, setCantDiasMatricula] = useState(0);
    const [tienePACPAT, setTienePACPAT] = useState(false);
    const [mesPagoArancel, setMesPagoArancel] = useState("");
    const [mesPagoMatricula, setMesPagoMatricula] = useState("");

    const [beneficios, setBeneficios] = useState([]);

    const [modalBeneficios, setModalBeneficios] = useState(false);

    const [matriculaPagada, setMatriculaPagada] = useState(false);
    const [arancelPagada, setArancelPagada] = useState(false);
    const [matriculaPagada2, setMatriculaPagada2] = useState(false);
    const [arancelPagada2, setArancelPagada2] = useState(false);

    const [matriculaSeleccionada, setMatriculaSeleccionada] = useState(false);
    const [arancelSeleccionada, setArancelSeleccionada] = useState(false);

    const [porcentajeDescuento, setPorcentajeAutomatico] = useState(0);
    const [codBeneficioAutomatico, setCodBeneficioAutomatico] = useState(0);
    const [codPagoBeneficioAutomatico, setCodPagoBeneficioAutomatico] = useState(0);

    const [tienecomplementario, setTienecomplementario] = useState(false);

    const [PP, setPP] = useState('');
    const [quiereCAE, setQuiereCAE] = useState(true);

    const [beneficioComplementarioSelec, setBeneficioComplementarioSelec] = useState('');
    const [beneficioComplementarioID, setBeneficioComplementarioID] = useState(0);

    const [openCAERechazar, setOpenCAERechazar] = useState(false);
    const [openCantDias, setOpenCantDias] = useState(false);
    const [openCAEAceptar, setOpenCAEAceptar] = useState(false);

    const [openCantDiasMostrado, setOpenCantDiasMostrado] = useState(false);

    const [teniaCAE, setTeniaCAE] = useState(false);

    const [arancelCuotas, setArancelCuotas] = useState(false);
    const [arancelWebPay, setArancelWebPay] = useState(false);

    const [cargandoValores, setCargandoValores] = useState(true);
    const [cargandoFP, setCargandoFP] = useState(true);

    const [idBeneficio, setIdBeneficio] = useState(0);

    const [error, setError] = useState(false);
    const [noTieneAranceles, setNoTieneAranceles] = useState(false);

    const [_base64, setBase64] = useState('');
    const [nombreAlumno, setNombreAlumno] = useState('');

    const [pagadoEsCF, setPagadoEsCF] = useState(false);
    const [hayPago, setHayPago] = useState(false);

    const [reintentar, setReintentar] = useState(false);
    const [cargarDatosIniciales, setCargarDatosIniciales] = useState(true);

    const [esNuevo, setEsNuevo] = useState(false);

    const [errorGuardarFP, setErrorGuardarFP] = useState(false);

    const [anoActual, setAnoActual] = useState(0);
    const [periodoActual, setPeriodoActual] = useState(0);

    const [valorArancelWebpay, setValorArancelWebpay] = useState(0.0);
    const [valorArancelCuotas, setValorArancelCuotas] = useState(0.0);
    const [valorArancelTransferencia, setValorArancelTransferencia] = useState(0.0);
    const [valorArancelPayPal, setValorArancelPayPal] = useState(0.0);
    const [valorMatriculaWebpay, setValorMatriculaWebpay] = useState(0.0);
    const [valorMatriculaWebpay2, setValorMatriculaWebpay2] = useState(0.0);
    const [valorMatriculaCuotas, setValorMatriculaCuotas] = useState(0.0);
    const [valorMatriculaTransferencia, setValorMatriculaTransferencia] = useState(0.0);
    const [valorMatriculaPayPal, setValorMatriculaPayPal] = useState(0.0);

    const [totalFaltanteMatricula, setTotalFaltanteMatricula] = useState(0);
    const [totalFaltanteArancel, setTotalFaltanteArancel] = useState(0);

    const [idMoneda, setIdMoneda] = useState(1);

    const [paridadUF, setParidadUF] = useState(0);
    const [paridadDolar, setParidadDolar] = useState(0);

    const [monedaOriginalMatricula, setMonedaOriginalMatricula] = useState(0);
    const [monedaOriginalArancel, setMonedaOriginalArancel] = useState(0);

    const [openModalFormasPago, setOpenModalFormasPago] = useState(false);

    const [menorPagadoWebpayMatricula, setMenorPagadoWebpayMatricula] = useState(false);
    const [menorPagadoWebpayArancel, setMenorPagadoWebpayArancel] = useState(false);

    const [cuotaMatricula, setCuotaMatricula] = useState(0);
    const [cuotaArancel, setCuotaArancel] = useState(0);

    const [fechaParidad, setFechaParidad] = useState('');

    const [montoPagoContado, setMontoPagoContado] = useState(0);
    const [guardar, setGuardar] = useState(true);

    const [verCuotasMatricula, setVerCuotasMatricula] = useState(false);
    const [verCuotasArancel, setVerCuotasArancel] = useState(false);

    const [cargando, setCargando] = useState(false);
    const [errorCargaParidad, setErrorCargaParidad] = useState(false);

    const [montoPagadoMatricula, setMontoPagoMatricula] = useState(0);
    const [montoPagadoArancel, setMontoPagoArancel] = useState(0);

    const [debeFirmar, setDebeFirmar] = useState(true);
    const [openCondiciones, setOpenCondiciones] = useState(false);
    const [_xml, setXML] = useState('');
    const [aceptoCondiciones, setAcepto] = useState(false);

    const [factArancel, setFactArancel] = useState(0);
    const [factMatricula, setFactMatricula] = useState(0);

    const [dialogFP, setDialogFP] = useState(false);
    const [formaPagoFP, setFormaPagoFP] = useState(1);
    const [MostrarDatosFacturacion, setMostrarDatosFacturacion] = useState(false);
    const [Editar, setEditar] = useState(Boolean);

    const [visualizarPACPAT, setVisualizarPACPAT] = useState(false);
    const [esFactura, setEsFactura] = useState(false)

    const [ChkFacturarDatosAlumno, setChkFacturarDatosAlumno] = useState(false);

    //formulario //FACTURACION
    const [RutFacturacion, setRutFacturacion] = useState('');
    const [RutPostulanteFacturacion, setRutPostulanteFacturacion] = useState('');

    const [RutFacturacionSF, setRutFacturacionSF] = useState(0);
    const [DV, setDV] = useState(String);
    const [NombreFacturacion, setNombreFacturacion] = useState(String);
    const [ApellidoP_Facturacion, setApellidoP_Facturacion] = useState(String);
    const [ApellidoM_Facturacion, setApellidoM_Facturacion] = useState(String);
    const [RazonSocial, setRazonSocial] = useState(String);
    const [CorreoFacturacion, setCorreoFacturacion] = useState(String);
    const [Telefono, setTelefono] = useState(String);
    const [Giro, setGiro] = useState(String);
    const [Direccion, setDireccion] = useState(String);

    const [ErrorFacturacion, setErrorFacturacion] = useState('');
    const _listComuna: IViewComunasAuto = { ID: 0, descripcion: '' };
    const [valComuna, setValComuna] = useState(_listComuna);
    const [CodigoComuna, setCodigoComuna] = useState(0);
    const [CodigoComuna_Postulacion, setCodigoComuna_Postulacion] = useState(0);
    const [NombreComuna, setNombreComuna] = useState('');
    const _comunasAuto: Array<IViewComunasAuto> = [];
    const [ListaComunasAuto, setListaComunasAuto] = useState(_comunasAuto);
    const [dialogFacturacion, setdialogFacturacion] = useState(false);
    const [DatosFacturacionGuardados, setDatosFacturacionGuardados] = useState(false);
    const [DatosEmpresaNueva, setDatosEmpresaNueva] = useState(false);
    const [DatosEmpresa, setDatosEmpresa] = useState(false);
    const [ComunaGuardar, setComunaGuardar] = useState(0)
    const [openModalToken, setOpenModalToken] = useState({ open: false, mnsj: "" })
    const handleSelectComuna = (event: any, newValue: any) => {
        if (newValue !== null) {
            setComunaGuardar(newValue.ID);
            setCodigoComuna(newValue.ID);
            setNombreComuna(newValue.descripcion);
            setValComuna(newValue)
        }
    }

    const Del_FacturacionInfoMatricula = () => {
        try {

            setRutFacturacion('')
            setRazonSocial('')
            setNombreFacturacion('')
            setApellidoP_Facturacion('')
            setApellidoM_Facturacion('')
            setCorreoFacturacion('')
            setDireccion('')
            setGiro('')
            setTelefono('')
            setNombreComuna('')
            setValComuna({ ID: 0, descripcion: '' })

            setDatosFacturacionGuardados(false)
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);
            Del_FacturacionInfoMatriculaLogic(
                SelDelFacturacionInfoMatricula,
                Number(_params.idProceso))
        } catch (error) {
            //alert('Del_FacturacionInfoMatricula')
        }
    }

    const SelDelFacturacionInfoMatricula = (error: Boolean, err: string, Comunas: IViewComunas[], _Comunas: IViewComunasAuto[]) => {
        try {
            if (error === false && Comunas.length > 0) {
                //elimina al cambiar a boleta
            }
        } catch (er) {
            //console.log('er', er);
        }
    }

    const handleValidarDatos = () => {
        setErrorFacturacion('');
        let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let regPhone = /^[0-9,+]*$/;
        try {
            if (RutFacturacion === "" || RutFacturacion === undefined) {
                setErrorFacturacion("Debe ingresar Rut facturacion.");
            } else if ((NombreFacturacion === "" || NombreFacturacion === undefined) && ChkFacturarDatosAlumno) {
                setErrorFacturacion("Debe ingresar nombre.");
                // }else if ((ApellidoP_Facturacion === "" || ApellidoP_Facturacion === undefined) && ChkFacturarDatosAlumno) {
                //     setErrorFacturacion("Debe ingresar apellido paterno.");
                // }else if ((ApellidoM_Facturacion === "" || ApellidoM_Facturacion === undefined) && ChkFacturarDatosAlumno) {
                //     setErrorFacturacion("Debe ingresar apellido materno.");
            } else if (RazonSocial === "" || RazonSocial === undefined) {
                setErrorFacturacion("Debe ingresar la razón social.");
            } else if (CorreoFacturacion === "" || CorreoFacturacion === undefined) {
                setErrorFacturacion("Debe ingresar correo facturación.");
            } else if (Giro === "" || Giro === undefined) {
                setErrorFacturacion("Debe ingresar Giro.");
            } else if (!regEmail.test(CorreoFacturacion)) {
                setErrorFacturacion("Debe ingresar correo facturación valido.");
                // }else if (!regPhone.test(Telefono)) {
                //     setErrorFacturacion("Debe ingresar teléfono correcto.");
            } else if (Direccion === "" || Direccion === undefined) {
                setErrorFacturacion("Debe ingresar Direccion.");
            } else if (ErrorFacturacion !== '') {
                //alert(ErrorFacturacion)
            } else {
                handleGrabarDatos()
            }

        } catch (e: any) {
            //setError(true);
            setErrorFacturacion("Error no controlado");
        }
    }

    const Get_ComunasHomologadas = (Cod_Comuna_Db_Docencia: number) => {
        try {
            ObtieneComunaHomologaLogic(
                SelObtieneComunaHomologa,
                0,
                '',
                Cod_Comuna_Db_Docencia
            )
        } catch (error) {
            console.log('Get_ComunasHomologadas ' + Cod_Comuna_Db_Docencia)
        }
    }

    const SelObtieneComunaHomologa = (error: Boolean, err: string, Resultado: any) => {
        try {
            if (error === false && Resultado !== undefined) {
                setComunaGuardar(Resultado.codComuna)

            } else {
                setErrorFacturacion("Error al Guardar los datos (servicio)");
            }
        } catch (err) {
            console.log('error', err);
        }
    }
    const handleGrabarDatos = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        let Rutcompleto = RutFacturacion.replaceAll('.', '').replace('-', '')
        let sRut = Rutcompleto.slice(0, -1)
        let nRut = parseInt(sRut)
        setRutFacturacionSF(nRut)
        let rutDV = Rutcompleto.slice(sRut.length, Rutcompleto.length).toUpperCase()
        setDV(rutDV)
        if (error === false) {
            GrabarFacturacionLogic(
                selGrabarDatosFacturacion,
                Number(_params.idProceso),
                nRut,
                rutDV,
                Giro,
                RazonSocial,
                CorreoFacturacion,
                Telefono.toString(),
                Direccion,
                ComunaGuardar,
                ChkFacturarDatosAlumno)
        }
    }

    const selGrabarDatosFacturacion = (error: Boolean, err: string, Resultado: any) => {
        try {
            if (error === false && Resultado !== undefined) {
                setMostrarDatosFacturacion(true)
                setDialogFP(false)
                setdialogFacturacion(false)
                setDatosFacturacionGuardados(true)
            } else {
                setErrorFacturacion("Error al Guardar los datos (servicio)");
            }
        } catch (err) {
            console.log('error', err);
        }
    }

    const handleCargarDatos = () => {
        let Rutcompleto = RutFacturacion.replaceAll('.', '').replace('-', '')
        let sRut = Rutcompleto.slice(0, -1)
        let nRut = parseInt(sRut)
        setRutFacturacionSF(nRut)
        setDV(Rutcompleto.slice(sRut.length, Rutcompleto.length).toUpperCase())
        Get_FacturacionInfoMatricula(nRut)
    }

    const Get_FacturacionInfoMatricula = (Rut: number = 0) => {
        try {
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);
            GetFacturacionInfoMatriculaLogic(
                SelGetFacturacionInfoMatricula,
                Number(_params.idProceso),
                Rut
            )
        } catch (error) {
        }
    }

    const SelGetFacturacionInfoMatricula = (error: Boolean, err: string, Resultado: any) => {
        try {
            setDatosEmpresaNueva(false)
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);
            if (Resultado !== undefined && Resultado !== '') {
                let _ttt = JSON.stringify(DatosAlumno);
                let _Alumno = JSON.parse(_ttt);
                setChkFacturarDatosAlumno(Resultado.alumno)
                if (Resultado.alumno) {
                }
                console.log('empresa ' + Resultado)
                setChkFacturarDatosAlumno(Resultado.alumno)
                setRutFacturacion(formatterRut(Resultado.ruT_FACTURACION + Resultado.dV_RUT))
                setRazonSocial(Resultado.razoN_SOCIAL)
                setNombreFacturacion(Resultado.razoN_SOCIAL)
                setCorreoFacturacion(Resultado.maiL_ENVIO_FACTURA)
                setTelefono(Resultado.telefono)
                setDireccion(Resultado.direccion)
                setGiro(Resultado.giro)
                setCodigoComuna(Resultado.iD_COMUNA)
                let _comuna = listaComunas.filter((e: IViewComunasAuto) => e.ID == Resultado.iD_COMUNA) // COMUNA DEL ALUMNO
                //let _comuna = listaComunas.filter((e:IViewComunasAuto)=>e.ID==0) // NO SE PRECARGA COMUNA PARA QUE SE SELECCIONE
                setValComuna({ ID: _comuna[0].ID, descripcion: _comuna[0].descripcion })
                setNombreComuna(_comuna[0].descripcion ?? 'NO DEFINIDA')

                setDatosFacturacionGuardados(true)
                setMostrarDatosFacturacion(true)
                setDialogFP(false)
                setFormaPagoFP(2)
                setEsFactura(true)
            } else {
                //setDatosFacturacionGuardados(false)
                let Rutcompleto = RutFacturacion.replaceAll('.', '').replace('-', '')
                let sRut = Rutcompleto.slice(0, -1)
                let nRut = parseInt(sRut)
                setRutFacturacionSF(nRut)
                setDV(Rutcompleto.slice(sRut.length, Rutcompleto.length).toUpperCase())
                ObtieneDatosFacturacionLogic(selCargarDatosFacturacion, _params.headers, sRut)
                ObtieneDatosPersonalesLogic(selCargarDatosPersonales, _params.headers, nRut, "", 0, 0, 0)
            }
            setDialogFP(false)
        } catch (err) {
            console.log('error', err);
        }
    }

    const selCargarDatosFacturacion = (error: Boolean, err: string, Resultado: any, event: any) => {
        try {
            if (error === false && Resultado !== undefined) {
                setFormaPagoFP(2)
                setEsFactura(true)
                setRazonSocial(Resultado.nombres)
                setNombreFacturacion(Resultado.nombres)
                setDireccion(Resultado.direccion)
                setGiro(Resultado.giro)
                setNombreComuna(Resultado.nombreComuna)
                setCodigoComuna(Resultado.codigoComuna)
                setValComuna({ ID: Resultado.codigoComuna, descripcion: Resultado.nombreComuna })
                setComunaGuardar(Resultado.codigoComuna)
                if (Resultado.nombres == '') {
                    setDatosEmpresaNueva(true)
                } else {
                    setDatosEmpresaNueva(false)
                }
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                } else {
                    console.log('no hay datos para cargar o hubo un error al obtenerlos')
                }
            }
        } catch (err) {
            console.log('error', err);
        }
    }

    const selCargarDatosPersonales = (error: Boolean, err: string, Resultado: any) => {
        try {
            if (error === false && Resultado !== undefined) {
                setCorreoFacturacion(Resultado[0].email)
                setTelefono(Resultado[0].telefono)
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (err) {
            console.log('error', err);
        }
    }

    //CHECK CARGAR DATOS ALUMNOS PARA FACTURAR
    const handleFacturarDatosAlumno = (Check: boolean) => {
        try {
            if (Check) {
                if (ChkFacturarDatosAlumno) {
                    Get_FacturacionInfoMatricula()
                } else {
                    setChkFacturarDatosAlumno(Check)
                    let _ttt = JSON.stringify(DatosAlumno);
                    let _Alumno = JSON.parse(_ttt);
                    if (_Alumno.run > 1) {
                        let Rutcompleto = _Alumno.runFormato.replaceAll('.', '').replace('-', '')
                        let sRut = Rutcompleto.slice(0, -1)
                        let nRut = parseInt(sRut)
                        setRutFacturacionSF(nRut)
                        setDV(Rutcompleto.slice(sRut.length, Rutcompleto.length).toUpperCase())
                        setRutPostulanteFacturacion(_Alumno.runFormato)
                        setRutFacturacion(_Alumno.runFormato)
                        setRazonSocial(_Alumno.nombreCompleto)
                        setNombreFacturacion(_Alumno.nombreCompleto)
                        setApellidoP_Facturacion(_Alumno.primerApellido)
                        setApellidoM_Facturacion(_Alumno.segundoApellido)
                        setCorreoFacturacion(_Alumno.email)
                        setTelefono(_Alumno.telefono)
                        setDireccion(_Alumno.direccion)
                        setGiro('')
                        setCodigoComuna(_Alumno.codigoComuna)
                        setNombreComuna(_Alumno.nombreComuna)
                        setValComuna({ ID: _Alumno.codigoComuna, descripcion: _Alumno.nombreComuna })
                        setCodigoComuna_Postulacion(_Alumno.codigoComuna)
                        Get_ComunasHomologadas(_Alumno.codigoComuna)
                    }
                }
            } else {
                setChkFacturarDatosAlumno(Check)
                setRutFacturacionSF(0)
                setRutFacturacion('')
                setRazonSocial('')
                setNombreFacturacion('')
                setApellidoP_Facturacion('')
                setApellidoM_Facturacion('')
                setCorreoFacturacion('')
                setDireccion('')
                setGiro('')
                setTelefono('')
                setNombreComuna('')
                setValComuna({ ID: 0, descripcion: '' })
            }
            setDialogFP(false)
        } catch (error) {
            console.log(error)
        }
    }

    const handleValidaRut = (RutFacturacion: string) => {
        try {
            setErrorFacturacion('');
            if (RutFacturacion.trim().length <= 12) {
                if (validarRUT(RutFacturacion.trim())) {
                    setDialogFP(false)
                    handleCargarDatos()
                    setRutFacturacion(formatterRut(RutFacturacion.trim()));
                    setRutIncorrecto(false)
                    setEstiloRut("form-control js-rut js-will-validate is-valid");
                    setDisableBotonIngresar(false);
                    if (error === true) {
                        setError(false);
                        setRutIncorrecto(false)
                        setmensajeError('');
                    }
                }
                else {
                    setEstiloRut("form-control js-rut js-will-validate is-invalid")
                    setDisableBotonIngresar(true)
                    setRutIncorrecto(true)
                    setErrorFacturacion('Rut incorrecto');
                    setmensajeError('')
                }
            }

            if (RutFacturacion.trim().length > 12) {
                setError(false);
                setRutFacturacion('');
                setRutIncorrecto(true)
                setEstiloRut('form-control js-rut js-will-validate');
                setDisableBotonIngresar(true);
            }

            if (RutFacturacion.trim().length < 8) {
                setError(false);
                setRutIncorrecto(true)
                setmensajeError('');
                setEstiloRut('form-control js-rut js-will-validate');
            }
        } catch (error) {
            setRutIncorrecto(true)
            setmensajeError('Ha ocurrido un error al validar el rut')
        }
    }

    const handleLimpiarFacturacion = () => {
        try {
            setDatosEmpresaNueva(true)
            if (ChkFacturarDatosAlumno) {
                setCorreoFacturacion('')
                setDireccion('')
                setGiro('')
                setTelefono('')
                setNombreComuna('')
                setValComuna({ ID: 0, descripcion: '' })
            } else {
                setRutFacturacion('')
                setRazonSocial('')
                setNombreFacturacion('')
                setApellidoP_Facturacion('')
                setApellidoM_Facturacion('')
                setCorreoFacturacion('')
                setDireccion('')
                setGiro('')
                setTelefono('')
                setNombreComuna('')
                setValComuna({ ID: 0, descripcion: '' })
            }
        } catch (error) {
            console.log('error', error);
        }
    }

    const handleCerrar = () => {
        try {
            if (ChkFacturarDatosAlumno) {
                if (DatosFacturacionGuardados === false) {
                    setRutFacturacion('')
                    setRazonSocial('')
                    setNombreFacturacion('')
                    setApellidoP_Facturacion('')
                    setApellidoM_Facturacion('')
                    setCorreoFacturacion('')
                    setDireccion('')
                    setGiro('')
                    setTelefono('')
                    setNombreComuna('')
                    setValComuna({ ID: 0, descripcion: '' })
                    setChkFacturarDatosAlumno(false)
                } else {
                    Get_FacturacionInfoMatricula()
                }
            } else {
                if (DatosFacturacionGuardados === false) {
                    setRutFacturacionSF(0)
                    setRutFacturacion('')
                    setRazonSocial('')
                    setNombreFacturacion('')
                    setApellidoP_Facturacion('')
                    setApellidoM_Facturacion('')
                    setCorreoFacturacion('')
                    setDireccion('')
                    setGiro('')
                    setTelefono('')
                    setNombreComuna('')
                    setValComuna({ ID: 0, descripcion: '' })
                } else {
                    Get_FacturacionInfoMatricula()
                }
            }
            setDialogFP(false)
        } catch (error) {
            console.log('error', error);
        }
    }

    const handleCambiarAboleta = () => {
        try {
            Del_FacturacionInfoMatricula()
            setMostrarDatosFacturacion(false)
        } catch (error) {
            console.log('error', error);
        }
    }

    const handleEditarFacturacion = () => {
        try {
            setRutFacturacionSF(0)
            setEditar(true)
            Get_FacturacionInfoMatricula()
            setdialogFacturacion(true)
        } catch (error) {

        }
    }

    useEffect(() => {
        if (RutFacturacion !== '' && formaPagoFP === 1 && ChkFacturarDatosAlumno === false) {
            setErrorFacturacion('');
            handleCargarDatos()
        }
    }, [RutFacturacionSF])

    useEffect(() => {
        if (RutFacturacion !== '' && formaPagoFP === 1 && ChkFacturarDatosAlumno === false) {
            setErrorFacturacion('');
            handleValidaRut(RutFacturacion)
        }
    }, [RutFacturacionSF])

    useEffect(() => {
        if (RutFacturacion !== '' && formaPagoFP === 1) {
            setRutFacturacion(formatterRut(RutFacturacion))
        }
    }, [RutFacturacion])

    const [OpenValidarDatosFacturacion, setOpenValidarDatosFacturacion] = useState(Boolean)
    const handleDatosFacturacioncompletos = () => {
        if (!DatosFacturacionGuardados && MostrarDatosFacturacion) {
            //alert('Completar datos facturación')            
            setOpenValidarDatosFacturacion(true)
            setOpenModalFormasPago(false)
        }

    }

    ////////////////////////// FIN FACTURACION

    useEffect(() => {
        if (reintentar) {
            setError(false);
            if (location.state === null || location.state === undefined) {
                history.push({
                    pathname: "/Inicio"
                });
            } else {
                handleCargaDatosInicialesx();
            }
            setReintentar(false);
        }
    }, [reintentar])

    useEffect(() => {
        if (location.state === null || location.state === undefined) {
            history.push({
                pathname: "/Inicio"
            });
        } else if (cargarDatosIniciales) {
            setCargarDatosIniciales(false);
            handleCargaDatosInicialesx();
        }
    }, [cargarDatosIniciales])

    useEffect(() => {
        if (idMoneda === 1) {
            listFormaPagoArancel.forEach(e => {
                if (e.nombreFormaPago === 'CUOTAS')
                    setValorArancelCuotas(e.montoCLP);
                if (e.nombreFormaPago === 'PayPal')
                    setValorArancelPayPal(e.montoCLP);
                if (e.nombreFormaPago === 'TRANSFERENCIA BANCARIA')
                    setValorArancelTransferencia(e.montoCLP);
                if (e.nombreFormaPago === 'WebPay')
                    setValorArancelWebpay(e.montoCLP);
            });

            listFormaPagoMatricula.forEach(e => {
                if (e.nombreFormaPago === 'CUOTAS')
                    setValorMatriculaCuotas(e.montoCLP);
                if (e.nombreFormaPago === 'PayPal')
                    setValorMatriculaPayPal(e.montoCLP);
                if (e.nombreFormaPago === 'TRANSFERENCIA BANCARIA')
                    setValorMatriculaTransferencia(e.montoCLP);
                if (e.nombreFormaPago === 'WebPay')
                    setValorMatriculaWebpay(e.montoCLP);
            });
        } else {
            listFormaPagoArancel.forEach(e => {
                if (e.nombreFormaPago === 'CUOTAS')
                    setValorArancelCuotas(e.montoUF);
                if (e.nombreFormaPago === 'PayPal')
                    setValorArancelPayPal(e.montoUF);
                if (e.nombreFormaPago === 'TRANSFERENCIA BANCARIA')
                    setValorArancelTransferencia(e.montoUF);
                if (e.nombreFormaPago === 'WebPay')
                    setValorArancelWebpay(e.montoUF);
            });
            listFormaPagoMatricula.forEach(e => {
                if (e.nombreFormaPago === 'CUOTAS')
                    setValorMatriculaCuotas(e.montoUF);
                if (e.nombreFormaPago === 'PayPal')
                    setValorMatriculaPayPal(e.montoUF);
                if (e.nombreFormaPago === 'TRANSFERENCIA BANCARIA')
                    setValorMatriculaTransferencia(e.montoUF);
                if (e.nombreFormaPago === 'WebPay')
                    setValorMatriculaWebpay(e.montoUF);
            });
        }
    }, [idMoneda])

    useEffect(() => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        /* console.log(_params) */
        if (modalBeneficios === false) {
            if (esNuevo) {
                if (tienecomplementario) {
                    if (idBeneficio !== 0) {
                        ObtieneBeneficioAutomaticoPorRutLogic(selListaBeneficiosPorRut, _params.codCarrera, idBeneficio, _params.rut);
                    }
                }
            }
        }
    }, [modalBeneficios])

    useEffect(() => {
        if (monedaOriginalMatricula > 0)
            ObtenerMonedasLogic(selListaMonedas);
    }, [monedaOriginalMatricula])

    const selListaProcesoActual2 = (error: boolean, err: string, data: any) => {
        try {
            if (error === false) {
                setAnoActual(parseInt(data.ano));
                setPeriodoActual(parseInt(data.periodo));
            }
        } catch (err) {
            console.log('error', err);
        }
    }

    useEffect(() => {
        if (fechaParidad !== '' && fechaParidad !== 'NaN-NaN-NaN') {
            ObtenerPariedadLogic(selListaParidadUF, 2, fechaParidad);
            ObtenerPariedadLogic(selListaParidadDolar, 3, fechaParidad);
        }
    }, [fechaParidad])

    useEffect(() => {
        setFormaPagoFP(esFactura ? 2 : 1);
    }, [esFactura])

    const selObtieneBeneficioAutomatico = (error: boolean, err: string, Resultado: any) => {
        try {
            if (error === false) {
                Resultado.map((e: any) => {
                    setPorcentajeAutomatico(parseFloat(e.arancel));
                    setCodBeneficioAutomatico(e.codigoBeneficio);
                    setCodPagoBeneficioAutomatico(e.formaPago);
                });
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (err) {
            console.log('error', err);
        }
    }
    const selObtenerSaldosPendientesPorPagar = (error: boolean, err: string, saldosPendientes: IViewSaldosPendientes) => {//matricula_: IViewDetalleAranceles, arancel_: IViewDetalleAranceles) => {
        try {
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);
            if (error === false) {
                setEsNuevo(saldosPendientes.esNuevo);
                if (saldosPendientes.esNuevo) {
                    if (saldosPendientes.saldoArancel.beneficioInterno != null) {
                        saldosPendientes.saldoArancel.beneficioInterno.map((e: any) => {
                            if (e.esComplementario) {
                                setIdBeneficio(parseInt(e.codigo));
                                ObtieneBeneficioComplementarioLogic(selListaBeneficios, _params.rut, 0, 0, parseInt(e.codigo), _params.codCarrera);
                                ObtieneBeneficioAutomaticoPorRutLogic(selListaBeneficiosPorRut, _params.codCarrera, parseInt(e.codigo), _params.rut);
                            }
                        });
                    }
                }
                setMonedaOriginalMatricula(saldosPendientes.saldoMatricula.arancelCodigoMoneda);
                if (saldosPendientes.saldoMatricula.arancelCodigoMoneda === 1) {
                    setIdMoneda(saldosPendientes.saldoMatricula.arancelCodigoMoneda);
                }
                setMonedaOriginalArancel(saldosPendientes.saldoArancel.arancelCodigoMoneda);
                setMatriculaDetalle(saldosPendientes.saldoMatricula);
                setArancelDetalle(saldosPendientes.saldoArancel);

                setTeniaCAE(saldosPendientes.tieneCAE);
                setTotalarancelSaldoFinalCLP(Math.round(saldosPendientes.saldoArancel.arancelSaldoFinalCLP));
                setTotalMatriculaSaldoFinalCLP(Math.round(saldosPendientes.saldoMatricula.arancelSaldoFinalCLP));
                setTotalArancelUF(saldosPendientes.saldoArancel.arancelMontoOriginal);
                setTotalMatriculaUF(saldosPendientes.saldoMatricula.arancelMontoOriginal);
                setTimeout(() => {
                    setCargandoValores(false);
                }, 2000);

                cargaFormaPagoMatricula(saldosPendientes.saldoMatricula.formaPago, saldosPendientes.saldoMatricula.arancelSaldoFinalCLP <= 0)
                cargaFormaPagoArancel(saldosPendientes.saldoArancel.formaPago, saldosPendientes.saldoArancel.arancelSaldoFinalCLP <= 0)

                if (saldosPendientes.saldoMatricula.arancelSaldoFinalCLP <= 0) {
                    setMatriculaPagada(true);
                    setMatriculaPagada2(true);
                    setMatriculaSeleccionada(true);
                }

                if (saldosPendientes.saldoArancel.arancelSaldoFinalCLP <= 0) {
                    setArancelPagada(true);
                    setArancelPagada2(true);
                    setArancelSeleccionada(true);
                }
                setFechaParidad(saldosPendientes.fechaPrimerPago.toString());
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                } else {
                    setError(true);
                }
            }
        } catch (err) {
            console.log('error', err);
        }
    }

    const cargaFormaPagoMatricula = (fp: IViewFormaPagoMulti[], pagada: boolean) => {
        try {
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);
            if (fp.length > 0) {
                fp.map((e: IViewFormaPagoMulti) => {
                    if (e.codigoFormaPago === 84) {
                        setPagadoEsCF(e.esCF != undefined ? e.esCF : false);
                        if (!esFactura) {
                            setEsFactura(e.esFactura != undefined ? e.esFactura : false);
                            setFormaPagoFP(e.esFactura != undefined ? (e.esFactura ? 2 : 1) : 1)
                        }
                        setValorMatriculaWebpay(0);
                        e.montoCLP = 0;
                        e.montoUF = 0;
                        e.seleccionado = false
                    } else if (e.codigoFormaPago === 118 || e.codigoFormaPago === 124) {
                        setCantDiasMatricula(0);
                        setValorMatriculaCuotas(0);
                        setMesPagoMatricula("");
                        if (_params.codigoNegocio === 1) {
                            setCuotaMatricula(e.cuotasMaximo);
                        } else {
                            setCuotaMatricula(e.cantCuotas);
                        }
                        e.montoCLP = 0;
                        e.montoUF = 0;
                        e.seleccionado = false
                    } else if (e.codigoFormaPago === con.codTransferencia()) {
                        setValorMatriculaTransferencia(0);
                        setHayPago(e.montoPagado > 0);
                        e.seleccionado = false
                        e.montoCLP = 0;
                        e.montoUF = 0;
                    }
                });
                setlistFormaPagoMatricula(fp);
            }

            setTimeout(() => {
                setCargandoFP(false);
            }, 2000);

        } catch (err) {
            console.log('error', err);
        }
    }

    const cargaFormaPagoArancel = (fp: IViewFormaPagoMulti[], pagada: boolean) => {
        try {
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);
            if (fp.length > 0) {
                fp.map((e: IViewFormaPagoMulti) => {
                    if (e.codigoFormaPago === 84) {
                        setHayPago(e.montoPagado > 0);
                        if (!esFactura) {
                            setEsFactura(e.esFactura != undefined ? e.esFactura : false);
                            setFormaPagoFP(e.esFactura != undefined ? (e.esFactura ? 2 : 1) : 1)
                        }
                        setValorArancelWebpay(0);
                        e.seleccionado = false
                        e.montoCLP = 0;
                        e.montoUF = 0;
                    } else if (e.codigoFormaPago === 118 || e.codigoFormaPago === 124) {
                        setValorArancelCuotas(0);
                        setMesPagoArancel("");
                        if (_params.codigoNegocio === 1) {
                            setCuotaArancel(e.cuotasMaximo);
                        } else {
                            setCuotaArancel(e.cantCuotas);
                        }
                        e.montoCLP = 0;
                        e.montoUF = 0;
                        e.seleccionado = false
                    } else if (e.codigoFormaPago === con.codTransferencia()) {
                        setHayPago(e.montoPagado > 0);
                        setValorArancelTransferencia(0);
                        e.seleccionado = false
                        e.montoCLP = 0;
                        e.montoUF = 0;
                    } else if (e.codigoFormaPago === 106) {
                        setMontoPagoContado(e.montoCLP);
                    }
                });
                setlistFormaPagoArancel(fp);
            }

            setTimeout(() => {
                setCargandoFP(false);
            }, 2000);

        } catch (err) {
            console.log('error', err);
        }
    }

    useEffect(() => {
        let _count = 0;
        setArancelWebPay(false);

        if (listFormaPagoArancel.length > 0) {
            listFormaPagoArancel.forEach(e => {
                _count = e.seleccionado ? _count + 1 : _count;

                if (e.seleccionado && e.montoCLP > 0 && totalarancelSaldoFinalCLP > 0 && (e.codigoFormaPago === 23 || e.codigoFormaPago === 84) && e.montoCLP === totalarancelSaldoFinalCLP) {
                    setArancelWebPay(true);
                }

                if (totalFaltanteArancel > 0) {
                    setArancelWebPay(false);
                }
            });
        }
        setArancelSeleccionada(_count > 0);
    }, [listFormaPagoArancel, totalFaltanteArancel])

    useEffect(() => {
        let _count = 0;
        if (listFormaPagoMatricula.length > 0) {
            listFormaPagoMatricula.forEach(e => {
                _count = e.seleccionado ? _count + 1 : _count;
            });
        }
        setMatriculaSeleccionada(_count > 0);

    }, [listFormaPagoMatricula])

    const HandleFormatFecha2 = (fecha: string) => {
        let f = new Date(fecha);
        let d = (f.getDate().toString().length === 1 ? ('0' + f.getDate()) : f.getDate()) + '-' + ((f.getMonth() + 1).toString().length === 1 ? ('0' + (f.getMonth() + 1)) : (f.getMonth() + 1)) + '-' + f.getFullYear();
        return d;
    }

    const handleCargaDatosInicialesx = () => {

        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        setCodNegocio(_params.codigoNegocio);
        setIdProcesoPostulante(Number(_params.idProceso));
        let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;

        if (!_params.debeFirmar) {
            ObtieneTieneFirmaContratoLogic(selListaFirma, _params.codigoNegocio, _params.rut, _params.codCarrera, _params.anioPromocion, _params.periodoPromocion, _params.codigoPlanificacionAcademica);
        }
        ObtieneProcesoActualLogic(selListaProcesoActual2);
        if (_params.codigoNegocio === 3) {
            ObtieneCondicionesLogic(selListaCondiciones, _params.rut);
        }
        ObtieneDocumentoPorAlumnoLogic(selListaDocumentoFacturacion, _params.headers, _params.rut, _params.codigoNegocio, _params.codCarrera, _params.codigoPlanificacionAcademica, 0, 0, idPeriodo);
        ObtieneEtapasLogic(selListaEtapas, _params.codigoNegocio, _params.codCarrera, _params.codigoPlanificacionAcademica, _params.rut, _params.anioPromocion, _params.periodoPromocion);
        ObtieneParametrosBoolLogic(selListaParametrosPACPAT, 'FAP');
        ObtieneParametrosLogic(selListaParametrosArancel, 'dma');
        ObtieneParametrosLogic(selListaParametrosMatricula, 'dmm');
        ObtieneBeneficioAutomaticoLogic(selObtieneBeneficioAutomatico, _params.headers, _params.codigoNegocio, _params.codCarrera);
        ObtenerPACPAT();
        if (_params.codigoNegocio === 1) {
            setNombreAlumno(_params.nombreAlumno);
        }
        else {
            ObtieneDatosPersonalesLogic(selListaPostulante, _params.headers, _params.rut, "", _params.codigoNegocio, 1, idPeriodo);
        }
        Get_FacturacionInfoMatricula()
    }

    const selListaCondiciones = (error: boolean, err: string, Instrucciones: any) => {
        if (error === false && Instrucciones !== undefined) {
            if (Instrucciones.length > 0) {
                setBase64(Instrucciones[0].instrucciones.base64[0].trim());
                setXML(Instrucciones[0].instrucciones.xml);
            }
        }
    }

    const selListaFirma = (error: boolean, err: string, data: any) => {
        if (error === false && data !== undefined) {
            setDebeFirmar(data);
        }
    }

    const selListaFecha1erPago = (error: boolean, err: string, data: any) => {
        try {
            if (error === false) {
                let _tt = JSON.stringify(location.state);
                let _params = JSON.parse(_tt);
                let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;

                if (data != "") {
                    let splitFecha = data.split('/');
                    let _fecha = splitFecha[2] + "/" + splitFecha[1] + "/" + splitFecha[0];
                    let fecha = new Date(_fecha);  //new Date(data);
                    if (fecha.toString() !== 'NaN/NaN/NaN' && fecha.toString() !== 'NaN-NaN-NaN') {
                        /* setFechaParidad(fecha.toString()); */
                        ObtieneSaldosPendientesPorPagarLogic(selObtenerSaldosPendientesPorPagar, _params.headers, _params.rut, _params.codCarrera, (_params.codCarrera.indexOf('S') === -1 ? 1 : 2), _params.idProceso, true, _params.codigoNegocio, _params.codigoPlanificacionAcademica, idPeriodo);
                    }
                }
            }
        } catch (err) {
            console.log('error', err);
        }
    }

    const selListaDocumentoFacturacion = (error: boolean, err: string, documento: any) => {
        try {
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);
            let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;
            if (error === false && documento !== undefined) {

                if (documento.idDocumento > 0) {

                    let fecha = new Date(documento.fechaEmision);
                    if (fecha.toString() !== 'NaN/NaN/NaN' && fecha.toString() !== 'NaN-NaN-NaN') {
                        /* setFechaParidad(fecha.toString()); */
                        ObtieneSaldosPendientesPorPagarLogic(selObtenerSaldosPendientesPorPagar, _params.headers, _params.rut, _params.codCarrera, (_params.codCarrera.indexOf('S') === -1 ? 1 : 2), _params.idProceso, true, _params.codigoNegocio, _params.codigoPlanificacionAcademica, idPeriodo);
                        setFactMatricula(documento.montoMatricula);
                        setFactArancel(documento.montoArancel);
                    }
                }
                else {
                    //console.log("llama ObtenerFecha1erPagoLogic");
                    ObtenerFecha1erPagoLogic(selListaFecha1erPago, _params.idProceso);
                }
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                } else {
                    //console.log("error llama ObtenerFecha1erPagoLogic");
                    ObtenerFecha1erPagoLogic(selListaFecha1erPago, _params.idProceso);
                }
            }

        } catch (err) {
            console.log('error', err);
        }
    }

    const selListaMonedas = (error: boolean, err: string, result: IViewCombo[]) => {
        try {
            if (error === false) {
                let aux: IViewCombo[] = [];
                result.map((e: IViewCombo) => {
                    if (e.ID === monedaOriginalMatricula || e.ID === 1) {
                        aux.push({ ID: e.ID, descripcion: e.descripcion })
                    }
                })
                setErrorCargaParidad(false);
            }
            else {
                setErrorCargaParidad(true);
            }
        } catch (error) {
            setErrorCargaParidad(true);
        }
    }

    const selListaParidadUF = (error: boolean, err: string, result: number) => {
        try {
            if (error === false) {
                setParidadUF(result);
                setErrorCargaParidad(false);
            }
            else {
                setErrorCargaParidad(true);
            }
        } catch (error) {
            setErrorCargaParidad(true);
        }
    }

    const selListaParidadDolar = (error: boolean, err: string, result: number) => {
        try {
            if (error === false) {
                setParidadDolar(result);
                setErrorCargaParidad(false);
            }
            else {
                setErrorCargaParidad(true);
            }
        } catch (error) {
            setErrorCargaParidad(true);
        }
    }
    const buscarMontoBeneficio = (data: boolean) => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);

        let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;
        ObtieneSaldosPendientesPorPagarLogic(selObtenerSaldosPendientesPorPagar, _params.headers, _params.rut, _params.codCarrera, (_params.codCarrera.indexOf('S') === -1 ? 1 : 2), _params.idProceso, data, _params.codigoNegocio, _params.codigoPlanificacionAcademica, idPeriodo);
    }

    const obtenerFecha = (fecha: string) => {
        let f = new Date(fecha);
        let d = f.getFullYear() + '-' + ((f.getMonth() + 1).toString().length === 1 ? ('0' + (f.getMonth() + 1)) : (f.getMonth() + 1)) + '-' + (f.getDate().toString().length === 1 ? ('0' + f.getDate()) : f.getDate());
        return d;
    }

    const selEnvioCorreo = (error: boolean, err: string, data: any) => {
        if (error === false && data !== undefined) {
            console.log("Se envío el correo exitosamente");
        } else {
            console.log("Problemas al enviar el correo");
        }
    }

    const selListaPostulante = (error: boolean, err: string, Estudiante: any) => {
        try {
            if (error === false && Estudiante[0].run.toString().trim().length > 1) {
                setNombreAlumno(Estudiante[0].nombreCompleto);
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (error) {
            console.log('error', error);
        }
    }

    const GuardarFormaPago = () => {
        setCargando(true);
        setErrorGuardarFP(false);
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);

        if (codNegocio === 3 && !debeFirmar) {
            EnvioCorreoDeclaracionLogic(selEnvioCorreo, _params.rut, _base64, nombreAlumno, _params.nombreCarrera, _params.codCarrera, _params.codigoPlanificacionAcademica);
        }

        // SI SOLO SELECCIONÓ CUOTAS, DEJARLO PASAAAAAAAAAAAR
        var data: any = []
        let valorOriginal = 0;
        let valorCLP = 0;
        let paridad = monedaOriginalMatricula === 1 ? 1 : monedaOriginalMatricula === 2 ? paridadUF : paridadDolar;
        let paridadArancel = monedaOriginalArancel === 1 ? 1 : monedaOriginalArancel === 2 ? paridadUF : paridadDolar;
        listFormaPagoMatricula.map(e => {
            valorOriginal = (e.montoCLP / paridad)
            valorCLP = e.montoCLP
            if (e.seleccionado) {
                if (e.montoCLP > 0) {
                    data.push(
                        {
                            "idProceso": _params.idProceso,
                            "codigoItem": e.codigoItem,
                            "formaPago": e.codigoFormaPago,
                            "diaPago": e.diaPago,
                            "mesPago": e.codigoFormaPago === 118 || e.codigoFormaPago === 124 ? mesPagoMatricula : "",
                            "moneda": monedaOriginalMatricula,
                            "monto": valorOriginal,
                            "montoClp": valorCLP,
                            "fechaActualizacion": obtenerFecha(fechaParidad),
                            "esBeca": false,
                            "tipoBeca": "",
                            "aplicaMonto": false,
                            "aplicaPorcentaje": false,
                            "codBen": 0,
                            "porcentaje": 0,
                            "cuotas": codNegocio === 1 ? e.cuotasMaximo : e.cantCuotas,
                            "pagado": e.pagado,
                            "es_cf": e.nombreFormaPago === 'COMP FACTURACIÓN' ? pagadoEsCF : false,
                            "es_factura": e.nombreFormaPago === 'WebPay' ? esFactura : false
                        });
                }
            }
        });

        listFormaPagoArancel.map(e => {
            valorOriginal = (e.montoCLP / paridadArancel)
            valorCLP = e.montoCLP
            if (e.seleccionado) {
                if (e.montoCLP > 0) {
                    data.push(
                        {
                            "idProceso": _params.idProceso,
                            "codigoItem": e.codigoItem,
                            "formaPago": e.codigoFormaPago,
                            "diaPago": e.diaPago,
                            "mesPago": e.codigoFormaPago === 118 || e.codigoFormaPago === 124 ? mesPagoArancel : "",
                            "moneda": monedaOriginalArancel,
                            "monto": valorOriginal,
                            "montoClp": valorCLP,
                            "fechaActualizacion": obtenerFecha(fechaParidad),
                            "esBeca": false,
                            "tipoBeca": "",
                            "aplicaMonto": false,
                            "aplicaPorcentaje": false,
                            "codBen": 0,
                            "porcentaje": 0,
                            "cuotas": codNegocio === 1 ? e.cuotasMaximo : e.cantCuotas,
                            "pagado": e.pagado,
                            "es_cf": false,
                            "es_factura": e.nombreFormaPago === 'WebPay' ? esFactura : false
                        }
                    );
                }
            }
        });

        if (arancelDetalle?.beneficioInterno != null && arancelDetalle?.beneficioInterno.length > 0) {

            arancelDetalle?.beneficioInterno.map((e: any) => {
                if (e.arancelMontoDescuentoCLP !== 0) {
                    data.push(
                        {
                            "idProceso": _params.idProceso,
                            "codigoItem": 21,
                            "formaPago": e.formaPago,
                            "diaPago": 0,
                            "mesPago": "0",
                            "moneda": 1,
                            "monto": e.montoDescuento,
                            "montoClp": e.montoDescuentoCLP,
                            "fechaActualizacion": obtenerFecha(fechaParidad),
                            "esBeca": true,
                            "tipoBeca": "UDD",
                            "aplicaMonto": false,
                            "aplicaPorcentaje": false,
                            "codBen": parseInt(e.codigo),
                            "porcentaje": e.porcentajeFinal,
                            "cuotas": 0,
                            "pagado": false,
                            "es_cf": false
                        });
                }
            });
        }

        if (arancelDetalle?.beneficioExterno != null && arancelDetalle?.beneficioExterno.length > 0) {

            arancelDetalle?.beneficioExterno.map((e: any) => {
                if (e.arancelMontoDescuentoCLP !== 0) {
                    data.push(
                        {
                            "idProceso": _params.idProceso,
                            "codigoItem": 21,
                            "formaPago": e.formaPago,
                            "diaPago": 0,
                            "mesPago": "0",
                            "moneda": 1,
                            "monto": e.montoDescuento,
                            "montoClp": e.montoDescuentoCLP,
                            "fechaActualizacion": obtenerFecha(fechaParidad),
                            "esBeca": true,
                            "tipoBeca": "EXT",
                            "aplicaMonto": false,
                            "aplicaPorcentaje": false,
                            "codBen": parseInt(e.codigo),
                            "porcentaje": e.porcentajeFinal,
                            "cuotas": 1,
                            "pagado": false,
                            "es_cf": false
                        });
                }
            });
        }

        if (arancelDetalle?.cae != null) {
            if (arancelDetalle.cae.montoDescuentoCLP !== 0) {
                data.push(
                    {
                        "idProceso": _params.idProceso,
                        "codigoItem": 21,
                        "formaPago": arancelDetalle.cae.formaPago,
                        "diaPago": 0,
                        "mesPago": "0",
                        "moneda": 1,
                        "monto": arancelDetalle.cae.montoDescuento,
                        "montoClp": arancelDetalle.cae.montoDescuentoCLP,
                        "fechaActualizacion": obtenerFecha(fechaParidad),
                        "esBeca": true,
                        "tipoBeca": "EXT",
                        "aplicaMonto": false,
                        "aplicaPorcentaje": false,
                        "codBen": parseInt(arancelDetalle.cae.codigo),
                        "porcentaje": arancelDetalle.cae.porcentajeFinal,
                        "cuotas": 1,
                        "pagado": false,
                        "es_cf": false
                    });
            }
        }

        //-------------------------------------------------------------------------------------------------------
        if (matriculaDetalle?.beneficioInterno != null && matriculaDetalle?.beneficioInterno.length > 0) {

            matriculaDetalle?.beneficioInterno.map((e: any) => {
                if (e.matriculaMontoDescuentoCLP !== 0) {
                    data.push(
                        {
                            "idProceso": _params.idProceso,
                            "codigoItem": 20,
                            "formaPago": e.formaPago,
                            "diaPago": 0,
                            "mesPago": "0",
                            "moneda": 1,
                            "monto": e.montoDescuento,
                            "montoClp": e.montoDescuentoCLP,
                            "fechaActualizacion": obtenerFecha(fechaParidad),
                            "esBeca": true,
                            "tipoBeca": "UDD",
                            "aplicaMonto": false,
                            "aplicaPorcentaje": false,
                            "codBen": parseInt(e.codigo),
                            "porcentaje": e.porcentajeFinal,
                            "cuotas": 0,
                            "pagado": false,
                            "es_cf": false
                        });
                }
            });
        }
        if (matriculaDetalle?.beneficioExterno != null && matriculaDetalle?.beneficioExterno.length > 0) {

            matriculaDetalle?.beneficioExterno.map((e: any) => {
                if (e.matriculaMontoDescuentoCLP !== 0) {
                    data.push(
                        {
                            "idProceso": _params.idProceso,
                            "codigoItem": 20,
                            "formaPago": e.formaPago,
                            "diaPago": 0,
                            "mesPago": "0",
                            "moneda": 1,
                            "monto": e.montoDescuento,
                            "montoClp": e.montoDescuentoCLP,
                            "fechaActualizacion": obtenerFecha(fechaParidad),
                            "esBeca": true,
                            "tipoBeca": "EXT",
                            "aplicaMonto": false,
                            "aplicaPorcentaje": false,
                            "codBen": parseInt(e.codigo),
                            "porcentaje": e.porcentajeFinal,
                            "cuotas": 1,
                            "pagado": false,
                            "es_cf": false
                        });
                }
            });

            if (matriculaDetalle?.cae != null) {
                if (matriculaDetalle.cae.montoDescuentoCLP !== 0) {
                    data.push(
                        {
                            "idProceso": _params.idProceso,
                            "codigoItem": 20,
                            "formaPago": matriculaDetalle.cae.formaPago,
                            "diaPago": 0,
                            "mesPago": "0",
                            "moneda": 1,
                            "monto": matriculaDetalle.cae.montoDescuento,
                            "montoClp": matriculaDetalle.cae.montoDescuentoCLP,
                            "fechaActualizacion": obtenerFecha(fechaParidad),
                            "esBeca": true,
                            "tipoBeca": "EXT",
                            "aplicaMonto": false,
                            "aplicaPorcentaje": false,
                            "codBen": parseInt(matriculaDetalle.cae.codigo),
                            "porcentaje": matriculaDetalle.cae.porcentajeFinal,
                            "cuotas": 1,
                            "pagado": false,
                            "es_cf": false
                        });
                }
            }
        }
        /* console.log(matriculaPagada2, arancelPagada2) */
        setTimeout(() => {
            GuardarFormaPagoLogic(selGuardarFormaPago, data, _params.idProceso, _params.codigoNegocio);
        }, 2000);
    }
    const selListaParametrosPACPAT = (error: boolean, err: string, Parametros: IViewParametrosMatricula[]) => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        try {
            if (error === false && Parametros.length > 0) {
                if (!Parametros[0].lVALOR) {
                    setVisualizarPACPAT(false);
                    ObtieneParametrosLogic(selListaParametrosArancel, 'dma');
                } else {
                    setVisualizarPACPAT(true);
                    ObtenerDatosAlumnoLogic(selListaPagoArancel, _params.rut, _params.codCarrera);
                }
            } else {
                setVisualizarPACPAT(false);
                ObtenerDatosAlumnoLogic(selListaPagoArancel, _params.rut, _params.codCarrera);
            }
        } catch (err) {
            setVisualizarPACPAT(false);
            ObtenerDatosAlumnoLogic(selListaPagoArancel, _params.rut, _params.codCarrera);
            console.log('error', err);
        }
    }

    const selListaParametrosArancel = (error: boolean, err: string, Parametros: IViewParametros[]) => {
        try {
            if (error === false && Parametros.length > 0) {
                setlistParamsArancel(Parametros);
            }
        } catch (err) {
            console.log('error', err);
        }
    }

    const selListaPagoArancel = (error: Boolean, err: string, Parametros: any) => {
        try {
            if (error === false) {
                if (Parametros.diaPago != 0) {
                    setTienePACPAT(true)
                    setCantDiasArancel(parseInt(Parametros.diaPago))
                    setVisualizarPACPAT(false)

                } else {
                    ObtieneParametrosLogic(selListaParametrosArancel, 'dma');
                }
            }
        } catch (err) {
            console.log('error', err)
        }
    }

    const selSiguienteEtapa = (error: boolean, err: string, Sig: any) => {
        if (error === false && Sig !== undefined) {
            console.log('selSiguienteEtapa', error);
        }
    }

    const selListaParametrosMatricula = (error: boolean, err: string, Parametros: IViewParametros[]) => {
        try {
            if (error === false && Parametros.length > 0) {
                setlistParamsMatricula(Parametros);
            }
        } catch (err) {
            console.log('error', err);
        }
    }

    const format = (num: number) => {
        const n = String(num),
            p = n.indexOf('.');
        //console.log(n)
        return n.replace(
            /\d(?=(?:\d{3})+(?:\.|$))/g,
            (m, i) => p < 0 || i < p ? `${m}.` : m
        )
    }

    useEffect(() => {
        var comboa: any = [];
        var combom: any = [];
        listParamsMatricula.map((e: IViewParametros) => {
            combom.push({
                key: e.sValor,
                text: e.sValor
            })
        })
        setcombParamsMatricula(combom);
        listParamsArancel.map((e: IViewParametros) => {
            comboa.push({
                key: e.sValor,
                text: e.sValor
            })
        })
        setcombParamsArancel(comboa);
        if (cantDiasMatricula === 0) {
            if (combom.length > 0) {
                setCantDiasMatricula(parseInt(combom[0].text));
            }
        }
        if (cantDiasArancel === 0) {
            if (comboa.length > 0) {
                //setCantDiasArancel(parseInt(comboa[0].text));
            }
        }
    }, [listParamsMatricula, listParamsArancel])

    useEffect(() => {
        var comboa: any = listDiasArancel;
        var combom: any = listDiasMatricula;
        if (cantDiasArancel > 0 && listDiasArancel.length === 1) {
            if (parseInt(comboa[0].text) !== cantDiasArancel) {
                /* setCantDiasArancel(30); */
                if (!openCantDiasMostrado) {
                    setOpenCantDias(true);
                    setOpenCantDiasMostrado(true);
                }
            }
        }

        if (cantDiasMatricula > 0 && listDiasMatricula.length === 1) {
            if (parseInt(combom[0].text) !== cantDiasMatricula) {
                setCantDiasMatricula(30);
                if (!openCantDiasMostrado) {
                    setOpenCantDias(true);
                    setOpenCantDiasMostrado(true);
                }
            }
        }
    }, [cantDiasArancel, listDiasArancel, cantDiasMatricula, listDiasMatricula]);

    useEffect(() => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;
        let idPersona = _params.idPeriodo === null ? 0 : _params.idPersona;

        if (_params.codigoNegocio !== 1) {
            if (cantDiasArancel > 0 && mesPagoArancel !== "") {
                ObtieneCuotasPagoLogic(selListaCuotasPagoArancel, _params.rut, cantDiasArancel, _params.codigoNegocio, 21, _params.codCarrera, mesPagoArancel, _params.codigoPlanificacionAcademica, idPeriodo, idPersona);
            }
        }
    }, [cantDiasArancel, mesPagoArancel]);

    const selListaEtapas = (error: boolean, err: string, Etapas: any) => {
        if (error === false && Etapas !== undefined) {
            let contrato: boolean = false;
            let pago: boolean = false;

            Etapas.map((e: IViewEtapas) => {
                if (e.nombre === 'Pago Web-Pay') {
                    pago = e.estado;
                }
                if (e.nombre === "Contrato") {
                    contrato = e.estado;
                }
            });

            ObtieneSiguienteEtapaLogic(selSiguienteEtapa, contrato, !pago);
        }
    }

    const selListaBeneficios = (error: boolean, err: string, beneficio: any) => {
        if (error === false) {
            setBeneficios(beneficio);
            if (beneficio.length === 0) {
                setTienecomplementario(false);
            } else {
                setTienecomplementario(true);
            }
        }
    }

    const selListaBeneficiosPorRut = (error: boolean, err: string, beneficio: any) => {
        if (error === false) {
            setBeneficioComplementarioSelec(beneficio.nombreComplementario);
            setBeneficioComplementarioID(beneficio.idClienteComplementario);
        }
    }

    const selGuardarFormaPago = (error: boolean, err: string, pago: any) => {
        if (error === false) {
            if (pago) {
                UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 3);
            } else {
                setCargando(false);
                setErrorGuardarFP(true);
            }
        } else {
            setCargando(false);
            setErrorGuardarFP(true);
        }
    }

    const selUpdateEtapa = (error: boolean, err: string, data: any) => {
        /* console.log(matriculaPagada2, arancelPagada2) */
        let _pagado = matriculaPagada2 && arancelPagada2;
        let _pagado2 = (valorArancelCuotas == arancelDetalle?.arancelSaldoFinalCLP && matriculaPagada2) || (valorMatriculaCuotas == matriculaDetalle?.arancelSaldoFinalCLP && arancelPagada2) || (valorMatriculaCuotas == matriculaDetalle?.arancelSaldoFinalCLP && valorArancelCuotas == arancelDetalle?.arancelSaldoFinalCLP)
        let todoPagado = _pagado ? _pagado : _pagado2;
        if (error === false && data !== undefined) {
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);
            //if ((todoPagado || pagoEnCuotas)) {
            if ((todoPagado)) {
                let debeCargarDocumentos: boolean = _params.codigoNegocio === 2 && _params.rut === _params.rutRF
                UpdateEtapaProcesoLogic(selUpdateEtapa2, idProcesoPostulante, 4, debeCargarDocumentos);

                if (!debeFirmar) {
                    UpdateEtapaProcesoLogic(selUpdateEtapa2, idProcesoPostulante, 5);
                    UpdateEtapaProcesoLogic(selUpdateEtapa2, idProcesoPostulante, 6);
                    onClickContinuar("7");
                    setOpenModalFormasPago(true);
                }
                else if (_params.codigoNegocio === 1) {
                    onClickContinuar("5");
                }
                else if (_params.codigoNegocio === 2) {
                    if ((_params.rut !== _params.rutRF)) {
                        onClickContinuar("5");
                    } else {
                        /* UpdateEtapaProcesoLogic(selUpdateEtapa2, idProcesoPostulante, 5); */
                        onClickContinuar("6");
                    }
                } else if (_params.codigoNegocio === 3) {
                    onClickContinuar("5");
                }
                setCargando(false);
            } else {
                onClickContinuar("4");
                setCargando(false);
            }
        } else {
            setCargando(false);
        }
    }

    const selUpdateEtapa2 = (error: boolean, err: string, data: any) => {
        if (error === false && data !== undefined) {
            console.log('selUpdateEtapa2', error);
        }
    }

    const selListaCuotasPagoMatricula = (error: boolean, err: string, result: number) => {
        if (error === false) {

            listFormaPagoMatricula.map((e: IViewFormaPagoMulti) => {
                if (e.nombreFormaPago === "CUOTAS") {
                    e.cantCuotas = result;
                }
            })
            if (result !== 0) {
                setCuotaMatricula(result);
            }
            setVerCuotasMatricula(true);
        }
    }

    const selListaCuotasPagoArancel = (error: boolean, err: string, result: number) => {
        if (error === false) {
            listFormaPagoArancel.map((e: IViewFormaPagoMulti) => {
                if (e.nombreFormaPago === "CUOTAS") {
                    e.cantCuotas = result;
                }
            })
            if (result !== 0) {
                setCuotaArancel(result);
            }
            setVerCuotasArancel(true);
        }
    }

    useEffect(() => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;
        let idPersona = _params.idPeriodo === null ? 0 : _params.idPersona;

        if ([3, 2].includes(_params.codigoNegocio)) {
            ObtieneMesesPagoLogic(selListaMesesPagoMatricula, _params.rut, cantDiasMatricula, _params.codigoNegocio, _params.codCarrera, "", _params.codigoPlanificacionAcademica, idPeriodo, idPersona);
        }
        if (cantDiasMatricula > 0) {
            listFormaPagoMatricula.map((e: IViewFormaPagoMulti) => {
                if (e.nombreFormaPago === "CUOTAS") {
                    e.diaPago = cantDiasMatricula;
                }
            });
        }

        if (_params.codigoNegocio !== 1) {
            if (cantDiasMatricula > 0 && mesPagoMatricula !== "") {
                ObtieneCuotasPagoLogic(selListaCuotasPagoMatricula, _params.rut, cantDiasMatricula, _params.codigoNegocio, 20, _params.codCarrera, mesPagoMatricula, _params.codigoPlanificacionAcademica, idPeriodo, idPersona);
            }
        }
    }, [cantDiasMatricula])

    useEffect(() => {
        if (cantDiasArancel > 0) {
            listFormaPagoArancel.map((e: IViewFormaPagoMulti) => {
                if (e.nombreFormaPago === "CUOTAS") {
                    e.diaPago = cantDiasArancel;
                }
            });
        }
    }, [listFormaPagoArancel])

    useEffect(() => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;
        let idPersona = _params.idPeriodo === null ? 0 : _params.idPersona;

        if ([3, 2].includes(_params.codigoNegocio)) {
            ObtieneMesesPagoLogic(selListaMesesPagoArancel, _params.rut, cantDiasArancel, _params.codigoNegocio, _params.codCarrera, "", _params.codigoPlanificacionAcademica, idPeriodo, idPersona);
        }
        if (cantDiasArancel > 0) {
            listFormaPagoArancel.map((e: IViewFormaPagoMulti) => {
                if (e.nombreFormaPago === "CUOTAS") {
                    e.diaPago = cantDiasArancel;
                }
            });
        }

        if (_params.codigoNegocio !== 1) {
            if (cantDiasArancel > 0 && mesPagoArancel !== "") {
                ObtieneCuotasPagoLogic(selListaCuotasPagoArancel, _params.rut, cantDiasArancel, _params.codigoNegocio, 21, _params.codCarrera, mesPagoArancel, _params.codigoPlanificacionAcademica, idPeriodo, idPersona);
            }
        }
    }, [cantDiasArancel])

    const selListaMesesPagoMatricula = (error: boolean, err: string, result: IViewCombo[]) => {
        if (error === false) {
            var combom: any = [];
            result.map((e: IViewCombo) => {
                combom.push({
                    key: e.ID,
                    text: e.descripcion
                })
            })
            setcombMesesMatricula(combom);
        }
    }

    const selListaMesesPagoArancel = (error: boolean, err: string, result: IViewCombo[]) => {
        if (error === false) {
            var combom: any = [];
            result.map((e: IViewCombo) => {
                combom.push({
                    key: e.ID,
                    text: e.descripcion
                })
            })

            setcombMesesArancel(combom);
        }
    }

    function transformarMiles(valor: string) {
        const valor1 = valor + "";
        let retornar = "0";
        var splitValor;
        if (valor !== "0") {
            if (valor1.indexOf('.') === -1) {
                retornar = parseInt(valor1).toLocaleString();
            } else {
                splitValor = valor1.split('.');
                retornar = parseInt(splitValor[0]).toLocaleString();
            }
        }
        return retornar;
    }

    function transformarMiles2(valor: string) {
        const valor1 = valor + "";
        let retornar = "0";
        let splitValor;
        if (valor !== "0") {
            if (valor1.indexOf('.') === -1) {
                retornar = parseInt(valor1).toLocaleString();
            } else {
                splitValor = valor1.split('.');
                retornar = parseInt(splitValor[0]).toLocaleString() + "," + splitValor[1];
            }
        }
        return retornar;
    }

    const AgregarPAC = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        InsertarClienteMandatoPagoLogic(selResultClienteMandato, _params.rut, _params.codCarrera, anoActual, periodoActual, 'PAC', 'MATWEB');
    }

    const AgregarPAT = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        InsertarClienteMandatoPagoLogic(selResultClienteMandato, _params.rut, _params.codCarrera, anoActual, periodoActual, 'PAT', 'MATWEB');
    }

    const ObtenerPACPAT = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        ObtenerClienteMandatoPagoLogic(selResultObtenerClienteMandato, _params.rut, _params.codCarrera, anoActual, periodoActual, '', '');
    }

    const EliminarPACPAT = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        EliminarClienteMandatoPagoLogic(selResultClienteMandato, _params.rut, _params.codCarrera, anoActual, periodoActual, '', '');
    }

    const selResultClienteMandato = (error: boolean, err: string, result: any) => {
        try {
            if (error === false) {
                ObtenerPACPAT();
            }
        } catch (err) {
            console.log('error', err);
        }
    }

    const selResultObtenerClienteMandato = (error: boolean, err: string, result: IViewClienteMandato) => {
        try {
            if (error === false) {
                setPP(result.tipoMandato);
            }
        } catch (err) {
            console.log('error', err);
        }
    }
    const beneficioNombre = (cambio: boolean = false, name: string = '') => {
        setModalBeneficios(false);
    }

    const handleSeleccionMatricula = (tipo: string, i: boolean, wp?: number) => {
        setCargandoMultiMatricula(true);
        let listt_aux2: IViewFormaPagoMulti[] = [];
        setlistFormaPagoMatricula(listt_aux2);
        setTimeout(() => {
            let listt_aux: IViewFormaPagoMulti[] = listFormaPagoMatricula;
            let valor = totalFaltanteMatricula < 0 ? 0 : totalFaltanteMatricula;
            listt_aux.forEach(w => {
                if ((w.nombreFormaPago === "WebPay") && tipo === w.nombreFormaPago) {
                    if (i) {
                        setValorMatriculaWebpay(valor);
                        w.seleccionado = true;
                        if (monedaOriginalMatricula === 1) {
                            w.montoCLP = valor;
                            w.montoUF = valor;
                        } else if (monedaOriginalMatricula === 2 && idMoneda === 1) {
                            w.montoCLP = valor;
                            w.montoUF = valor / paridadUF;
                        } else if (monedaOriginalMatricula === 2 && idMoneda === 2) {
                            w.montoCLP = valor * paridadUF;
                            w.montoUF = valor;
                        } else if (monedaOriginalMatricula === 3 && idMoneda === 1) {
                            w.montoCLP = valor;
                            w.montoUF = valor / paridadDolar;
                        } else if (monedaOriginalMatricula === 2 && idMoneda === 3) {
                            w.montoCLP = valor * paridadDolar;
                            w.montoUF = valor;
                        }
                    } else if (!i) {
                        w.seleccionado = false;
                        w.montoCLP = 0;
                        w.montoUF = 0;
                    }
                } else if ((w.nombreFormaPago === "CUOTAS") && tipo === w.nombreFormaPago) {
                    if (i) {
                        setValorMatriculaCuotas(valor);
                        w.seleccionado = true;
                        if (monedaOriginalMatricula === 1) {
                            w.montoCLP = valor;
                            w.montoUF = valor;
                        } else if (monedaOriginalMatricula === 2 && idMoneda === 1) {
                            w.montoCLP = valor;
                            w.montoUF = valor / paridadUF;
                        } else if (monedaOriginalMatricula === 2 && idMoneda === 2) {
                            w.montoCLP = valor * paridadUF;
                            w.montoUF = valor;
                        } else if (monedaOriginalMatricula === 3 && idMoneda === 1) {
                            w.montoCLP = valor;
                            w.montoUF = valor / paridadDolar;
                        } else if (monedaOriginalMatricula === 2 && idMoneda === 3) {
                            w.montoCLP = valor * paridadDolar;
                            w.montoUF = valor;
                        }
                    } else if (!i) {
                        w.seleccionado = false;
                        w.montoCLP = 0;
                        w.montoUF = 0;
                    }
                } else if ((w.nombreFormaPago === "TRANSFERENCIA BANCARIA") && tipo === w.nombreFormaPago) {
                    if (i) {
                        setValorMatriculaTransferencia(valor);
                        w.seleccionado = true;
                        if (monedaOriginalMatricula === 1) {
                            w.montoCLP = valor;
                            w.montoUF = valor;
                        } else if (monedaOriginalMatricula === 2 && idMoneda === 1) {
                            w.montoCLP = valor;
                            w.montoUF = valor / paridadUF;
                        } else if (monedaOriginalMatricula === 2 && idMoneda === 2) {
                            w.montoCLP = valor * paridadUF;
                            w.montoUF = valor;
                        } else if (monedaOriginalMatricula === 3 && idMoneda === 1) {
                            w.montoCLP = valor;
                            w.montoUF = valor / paridadDolar;
                        } else if (monedaOriginalMatricula === 2 && idMoneda === 3) {
                            w.montoCLP = valor * paridadDolar;
                            w.montoUF = valor;
                        }
                    } else if (!i) {
                        w.seleccionado = false;
                        w.montoCLP = 0;
                        w.montoUF = 0;
                    }
                }
            })
            setlistFormaPagoMatricula(listt_aux);
            setCargandoMultiMatricula(false);
        }, 1000)
    }
    const handleSeleccionArancel = (tipo: string, i: boolean, wp?: number) => {

        setCargandoMultiArancel(true);
        if (codNegocio === 1) {
            setArancelCuotas(false);
        }
        let listt_aux2: IViewFormaPagoMulti[] = [];
        setlistFormaPagoArancel(listt_aux2);

        setTimeout(() => {
            let listt_aux: IViewFormaPagoMulti[] = listFormaPagoArancel;
            let valor = totalFaltanteArancel < 0 ? 0 : totalFaltanteArancel;
            listt_aux.forEach(w => {
                if ((w.nombreFormaPago === "WebPay") && tipo === w.nombreFormaPago) {
                    if (i) {
                        setValorArancelWebpay(valor);
                        w.seleccionado = true;
                        if (monedaOriginalArancel === 1) {
                            w.montoCLP = valor;
                            w.montoUF = valor;
                        } else if (monedaOriginalArancel === 2 && idMoneda === 1) {
                            w.montoCLP = valor;
                            w.montoUF = valor / paridadUF;
                        } else if (monedaOriginalArancel === 2 && idMoneda === 2) {
                            w.montoCLP = valor * paridadUF;
                            w.montoUF = valor;
                        } else if (monedaOriginalArancel === 3 && idMoneda === 1) {
                            w.montoCLP = valor;
                            w.montoUF = valor / paridadDolar;
                        } else if (monedaOriginalArancel === 2 && idMoneda === 3) {
                            w.montoCLP = valor * paridadDolar;
                            w.montoUF = valor;
                        }
                    } else if (!i) {
                        w.seleccionado = false;
                        w.montoCLP = 0;
                        w.montoUF = 0;
                    }

                    setArancelWebPay(w.montoCLP === totalFaltanteArancel);

                } else if ((w.nombreFormaPago === "CUOTAS") && tipo === w.nombreFormaPago) {
                    if (i) {
                        setValorArancelCuotas(valor);
                        w.seleccionado = true;
                        if (codNegocio === 1) {
                            setArancelCuotas(true);
                        }
                        if (monedaOriginalArancel === 1) {
                            w.montoCLP = valor;
                            w.montoUF = valor;
                        } else if (monedaOriginalArancel === 2 && idMoneda === 1) {
                            w.montoCLP = valor;
                            w.montoUF = valor / paridadUF;
                        } else if (monedaOriginalArancel === 2 && idMoneda === 2) {
                            w.montoCLP = valor * paridadUF;
                            w.montoUF = valor;
                        } else if (monedaOriginalArancel === 3 && idMoneda === 1) {
                            w.montoCLP = valor;
                            w.montoUF = valor / paridadDolar;
                        } else if (monedaOriginalArancel === 2 && idMoneda === 3) {
                            w.montoCLP = valor * paridadDolar;
                            w.montoUF = valor;
                        }
                    } else if (!i) {
                        w.seleccionado = false;
                        w.montoCLP = 0;
                        w.montoUF = 0;
                    }
                } else if ((w.nombreFormaPago === "TRANSFERENCIA BANCARIA") && tipo === w.nombreFormaPago) {
                    if (i) {
                        setValorArancelTransferencia(valor);
                        w.seleccionado = true;
                        if (monedaOriginalArancel === 1) {
                            w.montoCLP = valor;
                            w.montoUF = valor;
                        } else if (monedaOriginalArancel === 2 && idMoneda === 1) {
                            w.montoCLP = valor;
                            w.montoUF = valor / paridadUF;
                        } else if (monedaOriginalArancel === 2 && idMoneda === 2) {
                            w.montoCLP = valor * paridadUF;
                            w.montoUF = valor;
                        } else if (monedaOriginalArancel === 3 && idMoneda === 1) {
                            w.montoCLP = valor;
                            w.montoUF = valor / paridadDolar;
                        } else if (monedaOriginalArancel === 2 && idMoneda === 3) {
                            w.montoCLP = valor * paridadDolar;
                            w.montoUF = valor;
                        }

                        /* if (w.montoCLP === totalFaltanteArancel) {
                            setArancelWebPay(true);
                        }
                        else {
                            setArancelWebPay(false);
                        } */
                    } else if (!i) {
                        w.seleccionado = false;
                        w.montoCLP = 0;
                        w.montoUF = 0;
                    }
                }
            })
            setlistFormaPagoArancel(listt_aux);
            setCargandoMultiArancel(false);
        }, 1000);
    }
    const onSelectMes = (mes: string) => {
        ObtieneDiasLogic(selListaDiasArancel, 'dma', mes);
    }
    const onSelectMes2 = (mes: string) => {
        ObtieneDiasLogic(selListaDiasMatricula, 'dmm', mes);
        setCantDiasMatricula(0);
    }

    const selListaDiasArancel = (error: boolean, err: string, Parametros: IViewParametros[]) => {
        let lista: any = [];
        try {
            if (error === false && Parametros.length > 0) {
                Parametros.map((e) => {
                    lista.push({
                        key: e.sValor,
                        text: e.sValor
                    })
                })
                setlistDiasArancel(lista);
            }
        } catch (err) {
            console.log('error', err);
        }
    }

    const selListaDiasMatricula = (error: boolean, err: string, Parametros: IViewParametros[]) => {
        let lista: any = [];
        try {
            if (error === false && Parametros.length > 0) {
                Parametros.map((e) => {
                    lista.push({
                        key: e.sValor,
                        text: e.sValor
                    })
                })
                setlistDiasMatricula(lista);
            }
        } catch (err) {
            console.log('error', err);
        }
    }

    const handleIngresarValores = (valor: number, formaPago: number, codigoItem: number) => {
        if (codigoItem === 20) {
            listFormaPagoMatricula.map((list: IViewFormaPagoMulti) => {
                if (list.codigoFormaPago === formaPago) {
                    if (monedaOriginalArancel === 1) {
                        list.montoCLP = valor;
                        list.montoUF = valor;
                    } else if (monedaOriginalArancel === 2 && idMoneda === 1) {
                        list.montoCLP = valor;
                        list.montoUF = valor / paridadUF;
                    } else if (monedaOriginalArancel === 2 && idMoneda === 2) {
                        list.montoCLP = valor * paridadUF;
                        list.montoUF = valor;
                    } else if (monedaOriginalArancel === 3 && idMoneda === 1) {
                        list.montoCLP = valor;
                        list.montoUF = valor / paridadDolar;
                    } else if (monedaOriginalArancel === 2 && idMoneda === 3) {
                        list.montoCLP = valor * paridadDolar;
                        list.montoUF = valor;
                    }
                }
            })
        } else {
            listFormaPagoArancel.map((list: IViewFormaPagoMulti) => {
                if (list.codigoFormaPago === formaPago) {
                    if (monedaOriginalArancel === 1) {
                        list.montoCLP = valor;
                        list.montoUF = valor;
                    } else if (monedaOriginalArancel === 2 && idMoneda === 1) {
                        list.montoCLP = valor;
                        list.montoUF = valor / paridadUF;
                    } else if (monedaOriginalArancel === 2 && idMoneda === 2) {
                        list.montoCLP = valor * paridadUF;
                        list.montoUF = valor;
                    } else if (monedaOriginalArancel === 3 && idMoneda === 1) {
                        list.montoCLP = valor;
                        list.montoUF = valor / paridadDolar;
                    } else if (monedaOriginalArancel === 2 && idMoneda === 3) {
                        list.montoCLP = valor * paridadDolar;
                        list.montoUF = valor;
                    }

                    if ((formaPago === 23 || formaPago === 84) && list.montoCLP === totalFaltanteArancel) {
                        setArancelWebPay(true);
                    }
                    else {
                        setArancelWebPay(false);
                    }
                }
            })
        }
    }


    useEffect(() => {
        /* console.log(totalMatriculaSaldoFinalCLP, idMoneda, valorMatriculaWebpay, valorMatriculaCuotas, valorMatriculaPayPal, valorMatriculaTransferencia) */
        setTotalFaltanteMatricula(totalMatriculaSaldoFinalCLP - (valorMatriculaWebpay + valorMatriculaCuotas + valorMatriculaPayPal + valorMatriculaTransferencia))
    }, [totalMatriculaSaldoFinalCLP, valorMatriculaWebpay, valorMatriculaCuotas, valorMatriculaPayPal, valorMatriculaTransferencia, idMoneda])

    useEffect(() => {
        /* console.log("totalarancelSaldoFinalCLP", totalarancelSaldoFinalCLP, "idMoneda", idMoneda, "valorArancelWebpay", valorArancelWebpay, "valorArancelCuotas", valorArancelCuotas, "valorArancelPayPal", valorArancelPayPal, "valorArancelTransferencia", valorArancelTransferencia) */
        setTotalFaltanteArancel(totalarancelSaldoFinalCLP - (valorArancelWebpay + valorArancelCuotas + valorArancelPayPal + valorArancelTransferencia))
    }, [totalarancelSaldoFinalCLP, valorArancelWebpay, valorArancelCuotas, valorArancelPayPal, valorArancelTransferencia, idMoneda])

    const cambiarFP = (entra: number) => {
        setFormaPagoFP(entra === 1 ? 2 : 1);
        setEsFactura(entra === 1 ? true : false)
        if (entra === 1) {
            setdialogFacturacion(true)
            setValorMatriculaCuotas(0);
            setValorMatriculaTransferencia(0);
            setValorArancelCuotas(0);
            setValorArancelTransferencia(0);
            handleSeleccionMatricula('CUOTAS', false);
            handleSeleccionArancel('CUOTAS', false);
            handleSeleccionMatricula('TRANSFERENCIA BANCARIA', false);
            handleSeleccionArancel('TRANSFERENCIA BANCARIA', false);
            let valorArancel = arancelDetalle!.arancelSaldoFinalCLP < 0 ? 0 : arancelDetalle!.arancelSaldoFinalCLP;
            let valorMatricula = matriculaDetalle!.arancelSaldoFinalCLP < 0 ? 0 : matriculaDetalle!.arancelSaldoFinalCLP;
            setValorMatriculaWebpay(valorMatricula);
            setValorArancelWebpay(valorArancel);
            listFormaPagoMatricula.map((i: IViewFormaPagoMulti) => {
                if (i.nombreFormaPago === 'WebPay') {
                    i.seleccionado = true;
                    i.montoCLP = valorMatricula;
                    i.montoUF = (valorMatricula / paridadUF);
                } else if (i.nombreFormaPago === "CUOTAS") {
                    i.seleccionado = false;
                } else if (i.codigoFormaPago === con.codTransferencia()) {
                    i.seleccionado = false;
                }
            })
            listFormaPagoArancel.map((i: IViewFormaPagoMulti) => {
                if (i.nombreFormaPago === 'WebPay') {
                    i.seleccionado = true;
                    i.montoCLP = valorArancel;
                    i.montoUF = (valorArancel / paridadUF);
                } else if (i.nombreFormaPago === "CUOTAS") {
                    i.seleccionado = false;
                } else if (i.codigoFormaPago === con.codTransferencia()) {
                    i.seleccionado = false;
                }
            })
        } else {
            handleCambiarAboleta()
        }
    }

    //FACTURACION
    const { validarRUT } = require('validar-rut')
    const { formatterRut, cleanRut } = require('chilean-formatter')
    const [rutIncorrecto, setRutIncorrecto] = useState(false)
    //const [rut, setRut] = useState('');
    const [estiloRut, setEstiloRut] = useState('form-control js-rut js-will-validate');
    const [mensajeError, setmensajeError] = useState('')
    const [DisableBotonIngresar, setDisableBotonIngresar] = useState(false);




    return (
        <>{
            error ?
                <div className="site-main__container">
                    <div style={{ marginBottom: '2rem', color: 'gray', fontSize: '1rem' }}>
                        <div className="enrollment__subtitle"></div>
                    </div>
                    <div style={{ textAlign: 'center', marginTop: 100 }}>

                        <ErrorOutlineRounded style={{ fontSize: 50, color: 'red' }} />
                        <br />
                        <a><span>Ocurrió un problema al obtener tus formas de pagos, favor comunicarse con la universidad.</span></a>
                        <br />
                        <Button style={{ border: '1px solid gray' }} onClick={() => setReintentar(true)} color="inherit">Reintentar cargar pagos</Button>

                    </div>
                </div>
                :
                noTieneAranceles ?
                    <div className="site-main__container">
                        <div style={{ fontSize: 12, border: 'solid #0062a1 2px', padding: '2%', margin: '5% 10% 10% 10%' }}>
                            <div style={{ textAlign: 'center' }}>
                                <ErrorOutlineRounded style={{ fontSize: 50, color: 'red' }} />
                            </div>
                            <div style={{ marginLeft: '10%', fontSize: '1rem' }} className="enrollment__subtitle">Estimado(a)</div>
                            <div style={{ marginLeft: '10%', fontSize: '1rem' }} className="enrollment__subtitle">Ocurrió un problema con los valores de los Aranceles.</div>
                            <div style={{ marginLeft: '10%', fontSize: '1rem' }} className="enrollment__subtitle">Comuníquese con nosotros a través de: <a style={{ fontWeight: 'bold' }} href="https://contacto.udd.cl/"><u>https://contacto.udd.cl/</u></a>.</div>
                            <br></br>
                            <div style={{ marginLeft: '10%', fontSize: '1rem' }} className="enrollment__subtitle">Matrículas</div>
                            <div style={{ marginLeft: '10%', fontSize: '1rem' }} className="enrollment__subtitle">Universidad del Desarrollo</div>
                        </div>
                    </div>
                    :
                    errorCargaParidad ?
                        <div style={{ fontSize: 12, border: 'solid #0062a1 2px', padding: '2%', margin: '5% 10% 10% 10%' }}>
                            <div style={{ marginLeft: '10%', fontSize: '1rem' }} className="enrollment__subtitle">Estimado (a)</div>
                            <div style={{ marginLeft: '10%', fontSize: '1rem' }} className="enrollment__subtitle">Tenemos inconvenientes en procesar su matrícula.</div>
                            <div style={{ marginLeft: '10%', fontSize: '1rem' }} className="enrollment__subtitle">Por favor intente más tarde o comuníquese con nosotros a través de: <a style={{ fontWeight: 'bold' }} href="https://contacto.udd.cl/"><u>https://contacto.udd.cl/</u></a>.</div>
                            <br></br>
                            <div style={{ marginLeft: '10%', fontSize: '1rem' }} className="enrollment__subtitle">Matrículas</div>
                            <div style={{ marginLeft: '10%', fontSize: '1rem' }} className="enrollment__subtitle">Universidad del Desarrollo</div>
                        </div>
                        :
                        <main className="site-main enrollment">
                            {cargandoFP || cargandoValores ?
                                <div className="site-main__container">
                                    <div style={{ textAlign: 'center', marginTop: 100 }}>

                                        <CircularProgress disableShrink />
                                        <br />
                                        <a><span>Cargando datos</span></a>

                                    </div>
                                </div>
                                :
                                <div className="site-main__container">
                                    <div style={{ marginTop: '-3rem', marginBottom: '1rem' }} >
                                        <div style={{ fontSize: '1rem' }}>
                                            {/* <div style={{ display: 'list-item' }} className="enrollment__subtitle">A continuación debe elegir la forma de pago para la Matrícula y Arancel según corresponda.</div> */}
                                            <div style={{ display: 'list-item' }} className="enrollment__subtitle">Seleccionar forma de pago para Matrícula y Arancel según corresponda.</div>
                                            <div style={{ display: 'list-item' }} className="enrollment__subtitle">Si la opción es Webpay, en la siguiente etapa tendrá la posibilidad de pagar con más de una tarjeta si lo requiere.</div>
                                            {factArancel > 0 || factMatricula > 0 || codNegocio == 1  /*|| pagadoEsCF */ || hayPago ? "" :
                                                formaPagoFP === 1 ?
                                                    <div style={{ display: 'list-item' }} className="enrollment__subtitle">La forma de pago predeterminada es <b>Boleta</b>, si desea cambiar a Factura seleccione <a style={{ cursor: 'pointer', color: 'blue', fontWeight: 'bold', textDecoration: 'underline' }} onClick={() => { setDialogFP(true) }}>aquí</a>.</div>
                                                    :
                                                    <div style={{ display: 'list-item' }} className="enrollment__subtitle">Seleccionó forma de pago <b>Factura</b> la cual solo permite pago con WebPay, si desea cambiar a Boleta seleccione <a style={{ cursor: 'pointer', color: 'blue', fontWeight: 'bold', textDecoration: 'underline' }} onClick={() => { setDialogFP(true) }}>aquí</a>.</div>}
                                            {esFactura && hayPago ?
                                                <div style={{ display: 'list-item' }} className="enrollment__subtitle">Seleccionó forma de pago <b>Factura</b> la cual solo permite pago con WebPay.</div>
                                                : ""}
                                        </div>
                                    </div>
                                    {MostrarDatosFacturacion === true ?
                                        <div className="payment-selection" style={{ padding: "5px 50px" }}>
                                            <DialogContent style={{ padding: 0, overflow: "hidden" }}>
                                                <h5><span>DATOS DE FACTURACIÓN</span></h5>
                                                <Grid container spacing={2} style={{ margin: 0, padding: 0 }} >
                                                    <Grid item xs={12} sm={6} md={6} xl={6}>
                                                        <label style={{ width: '12rem' }} className="text-nowrap">{`Rut`}</label>:
                                                        <label style={{ width: '12rem' }} className="text-nowrap">{RutFacturacion !== '' ? RutFacturacion : ''}</label>
                                                        <br />
                                                        {ChkFacturarDatosAlumno == true ?
                                                            <div>
                                                                <label style={{ width: '12rem' }} className="text-nowrap">{`Nombres y Apellidos`}</label>:
                                                                <label style={{ width: '12rem' }} className="text-nowrap">{NombreFacturacion}</label>
                                                            </div>
                                                            :
                                                            <div>
                                                                <label style={{ width: '12rem' }} className="text-nowrap">{`Razón Social`}</label>:
                                                                <label style={{ width: '12rem' }} className="text-nowrap">{RazonSocial}</label>
                                                            </div>
                                                        }
                                                        <label style={{ width: '12rem' }} className="text-nowrap">{`Correo envío factura`}</label>:
                                                        <label style={{ width: '12rem' }} className="text-nowrap">{CorreoFacturacion}</label>
                                                        <br />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6} xl={6}>
                                                        <label style={{ width: '12rem' }} className="text-nowrap">{`Teléfono`}</label>:
                                                        <label style={{ width: '12rem' }} className="text-nowrap">{Telefono}</label>
                                                        <br />
                                                        <label style={{ width: '12rem' }} className="text-nowrap">{`Direccion`}</label>:
                                                        <label style={{ width: '12rem' }} className="text-nowrap">{Direccion}</label>
                                                        <br />
                                                        <label style={{ width: '12rem' }} className="text-nowrap">{`Giro`}</label>:
                                                        <label style={{ width: '12rem' }} className="text-nowrap">{Giro}</label>
                                                        <br />
                                                        <label style={{ width: '12rem' }} className="text-nowrap">{`Comuna`}</label>:
                                                        <label style={{ width: '12rem' }} className="text-nowrap">{NombreComuna}</label>
                                                        <br />
                                                        <Button style={{ width: '5rem', border: '1px solid gray', backgroundColor: '#009cff', color: 'white' }} onClick={handleEditarFacturacion}>Editar</Button>
                                                    </Grid>
                                                </Grid>
                                            </DialogContent>
                                        </div>
                                        :
                                        <div></div>
                                    }
                                    <div style={{ marginBottom: '2rem', color: 'gray', fontSize: '1rem' }}>
                                        {
                                            monedaOriginalMatricula !== 1 ?
                                                <div style={{ float: 'right', marginTop: -93 }}>
                                                    <br />
                                                    {
                                                        idMoneda > 0 ?
                                                            <div>
                                                                {
                                                                    <div className='btn-flotante'>
                                                                        {monedaOriginalMatricula === 2 ? <label className="text-nowrap"> {`Valor UF a la fecha ${HandleFormatFecha2(fechaParidad !== '' ? fechaParidad : new Date().toString())} es: $${transformarMiles2(paridadUF.toString())}`}</label> : ""}
                                                                        {monedaOriginalMatricula === 3 ? <label className="text-nowrap">{`Valor DOLAR a la fecha ${HandleFormatFecha2(fechaParidad !== '' ? fechaParidad : new Date().toString())} es: $${transformarMiles2(paridadDolar.toString())}`}</label> : ""}
                                                                    </div>
                                                                }
                                                            </div>
                                                            :
                                                            ""
                                                    }
                                                </div>
                                                :
                                                ""
                                        }
                                    </div>

                                    <div className="payment-selection mb-2">
                                        <h3 className="payment-selection__title">Matrícula</h3>
                                        <DetalleMontoAranceles detalleAranceles={matriculaDetalle} className={"payment-selection__table table w-50"}></DetalleMontoAranceles>
                                        {
                                            matriculaDetalle!.arancelSaldoFinalCLP > 0 ?
                                                <div>
                                                    <h3 className="payment-selection__title ml-2"><small><strong>Formas de pago disponible para Matrícula</strong></small></h3>
                                                    <div className="payment-selection__ways ml-2" style={{ display: 'grid' }}>
                                                        {cargandoMultiMatricula ?
                                                            <div className="site-main__container" style={{ backgroundColor: 'rgb(242 247 250)' }}>
                                                                <div style={{ textAlign: 'center' }}>

                                                                    <CircularProgress disableShrink />
                                                                    <br />
                                                                    <a><span>Cargando datos</span></a>

                                                                </div>
                                                            </div>
                                                            :
                                                            <div style={{ width: '110%' }}>
                                                                <table>
                                                                    <thead>
                                                                        <th style={{ width: '17rem' }}></th>
                                                                        {monedaOriginalMatricula === 1 ? "" : <th style={{ width: '8rem', textAlign: 'center' }}>{monedaOriginalMatricula === 2 ? "UF" : "USD"}</th>}
                                                                        <th style={{ width: '8rem', textAlign: 'center' }}>CLP</th>
                                                                    </thead>
                                                                </table>
                                                                <Box sx={{ display: 'flex' }}>
                                                                    <FormControl component="fieldset" variant="standard">
                                                                        <FormGroup>
                                                                            {
                                                                                listFormaPagoMatricula.map((i: IViewFormaPagoMulti) => {
                                                                                    if (i.nombreFormaPago === 'WebPay') {
                                                                                        return (
                                                                                            <div>
                                                                                                <div style={{ display: 'block', width: '130%' }}>
                                                                                                    <FormControlLabel
                                                                                                        control={
                                                                                                            <Checkbox
                                                                                                                checked={i.seleccionado}
                                                                                                                onChange={(e, h) => {
                                                                                                                    handleSeleccionMatricula('WebPay', h, 1)
                                                                                                                    if (!h) {
                                                                                                                        setValorMatriculaWebpay(0)
                                                                                                                    }
                                                                                                                }}
                                                                                                            />
                                                                                                        }
                                                                                                        label={''}
                                                                                                    />
                                                                                                    <label style={{ width: '14rem' }} className="text-nowrap">{`WEBPAY`}</label>
                                                                                                    {
                                                                                                        monedaOriginalMatricula === 1 ?
                                                                                                            ""
                                                                                                            :
                                                                                                            <input
                                                                                                                disabled={true}
                                                                                                                style={{ width: 130, height: 30, border: 1 }}
                                                                                                                value={(parseFloat((valorMatriculaWebpay / (monedaOriginalMatricula === 2 ? paridadUF : paridadDolar)).toFixed(2).toString()))}
                                                                                                                type={"number"}>

                                                                                                            </input>
                                                                                                    }
                                                                                                    <input
                                                                                                        disabled={!i.seleccionado}
                                                                                                        style={{ width: 130, height: 30, border: 1 }}
                                                                                                        value={format(parseInt(valorMatriculaWebpay.toString()))}
                                                                                                        type={"text"}
                                                                                                        onChange={(o) => {
                                                                                                            if (parseInt(o.target.value.replaceAll('.', '')) >= 0) {
                                                                                                                setValorMatriculaWebpay(parseInt(o.target.value.replaceAll('.', '')))
                                                                                                            }
                                                                                                        }}
                                                                                                        onBlur={(o) => {
                                                                                                            if (parseFloat(o.target.value.replaceAll('.', '')) >= 0) {
                                                                                                                handleIngresarValores(parseFloat(o.target.value.replaceAll('.', '')), i.codigoFormaPago, i.codigoItem)
                                                                                                            }
                                                                                                        }}>
                                                                                                    </input>
                                                                                                </div>
                                                                                            </div>
                                                                                        )
                                                                                    } else if (i.nombreFormaPago === "CUOTAS" && !esFactura) {
                                                                                        return (
                                                                                            <div style={{ display: 'inline' }}>
                                                                                                <div style={{ display: 'flex' }}>
                                                                                                    <FormControlLabel
                                                                                                        control={
                                                                                                            <Checkbox
                                                                                                                checked={i.seleccionado}
                                                                                                                onChange={(e, h) => {
                                                                                                                    handleSeleccionMatricula('CUOTAS', h)
                                                                                                                    if (!h) {
                                                                                                                        setValorMatriculaCuotas(0)
                                                                                                                    }
                                                                                                                }}
                                                                                                            />
                                                                                                        }
                                                                                                        label={''}
                                                                                                    />
                                                                                                    <label style={{ width: '14rem', marginTop: '0.6rem' }} className="text-nowrap">{`${'CUOTAS'}`}</label>
                                                                                                    {
                                                                                                        monedaOriginalMatricula === 1 ?
                                                                                                            ""
                                                                                                            :
                                                                                                            <input
                                                                                                                disabled={true}
                                                                                                                style={{ width: 130, height: 30, border: 1 }}
                                                                                                                value={parseFloat((valorMatriculaCuotas / (monedaOriginalMatricula === 2 ? paridadUF : paridadDolar)).toFixed(2).toString())}
                                                                                                                type={"number"}>

                                                                                                            </input>
                                                                                                    }
                                                                                                    <input
                                                                                                        disabled={!i.seleccionado}
                                                                                                        style={{ width: 130, height: 30, border: 1 }}
                                                                                                        value={format(parseInt(valorMatriculaCuotas.toString()))}
                                                                                                        type={"text"}
                                                                                                        onChange={(o) => {
                                                                                                            if (parseInt(o.target.value.replaceAll('.', '')) >= 0) {
                                                                                                                setValorMatriculaCuotas(parseInt(o.target.value.replaceAll('.', '')))
                                                                                                            }
                                                                                                        }}
                                                                                                        onBlur={(o) => {
                                                                                                            if (parseInt(o.target.value.replaceAll('.', '')) >= 0) {
                                                                                                                handleIngresarValores(parseInt(o.target.value.replaceAll('.', '')), i.codigoFormaPago, i.codigoItem)
                                                                                                            }
                                                                                                        }}>
                                                                                                    </input>
                                                                                                    &nbsp;
                                                                                                    {
                                                                                                        verCuotasMatricula ?
                                                                                                            <>
                                                                                                                <label className="text-nowrap" style={{ marginTop: 10 }}>{listFormaPagoMatricula.map((e: IViewFormaPagoMulti) => {
                                                                                                                    if (monedaOriginalMatricula !== 1) {
                                                                                                                        if (e.nombreFormaPago === "CUOTAS" && cantDiasMatricula > 0) {
                                                                                                                            return (
                                                                                                                                <p>{`${codNegocio === 1 || codNegocio === 2 ? e.cuotasMaximo : e.cantCuotas} Cuotas de un valor de ${parseFloat((e.montoUF / (codNegocio === 1 ? e.cuotasMaximo : e.cantCuotas)).toString()).toFixed(2)} `}{monedaOriginalMatricula === 2 ? 'UF' : 'USD'}</p>
                                                                                                                            )
                                                                                                                        }
                                                                                                                    } else {
                                                                                                                        if (e.nombreFormaPago === "CUOTAS" && cantDiasMatricula > 0) {
                                                                                                                            return (
                                                                                                                                <p>{e.nombreFormaPago === "CUOTAS" ? `${codNegocio === 1 ? e.cuotasMaximo : e.cantCuotas} Cuotas de un valor de $${transformarMiles((e.montoCLP / (codNegocio === 1 ? e.cuotasMaximo : e.cantCuotas)).toString())} ` : `$${transformarMiles(e.montoCLP.toString())}`}</p>
                                                                                                                            )
                                                                                                                        }
                                                                                                                    }
                                                                                                                })}</label>  &nbsp;&nbsp;
                                                                                                                <u onClick={() => {
                                                                                                                    setVerCuotasMatricula(false)
                                                                                                                }} className="text-nowrap" style={{ color: '#0062a1', cursor: 'pointer', marginTop: '0.5rem' }} >Cambiar fecha de pago</u>
                                                                                                            </>
                                                                                                            :
                                                                                                            <>
                                                                                                                {
                                                                                                                    codNegocio === 1 ?
                                                                                                                        ""
                                                                                                                        :
                                                                                                                        <>
                                                                                                                            <label className="text-nowrap" style={{ marginTop: 10 }}>{`Mes de inicio de pago `}</label> &nbsp;&nbsp;
                                                                                                                            <ComboBox
                                                                                                                                disabled={!i.seleccionado}
                                                                                                                                defaultChecked
                                                                                                                                style={{ width: 80 }}
                                                                                                                                autoComplete='off'
                                                                                                                                options={combMesesMatricula}
                                                                                                                                selectedKey={mesPagoMatricula}
                                                                                                                                onChange={(e, i) => {
                                                                                                                                    onSelectMes2(i!.key.toString());
                                                                                                                                    setMesPagoMatricula(i!.key.toString())
                                                                                                                                }}

                                                                                                                            ></ComboBox>&nbsp;&nbsp;&nbsp;&nbsp;
                                                                                                                        </>
                                                                                                                }
                                                                                                                &nbsp;&nbsp;
                                                                                                                <label className="text-nowrap" style={{ marginTop: 10 }}>{`Día de pago`}</label>&nbsp;&nbsp;
                                                                                                                {codNegocio === 1 ?
                                                                                                                    <ComboBox
                                                                                                                        disabled={!i.seleccionado}
                                                                                                                        defaultChecked
                                                                                                                        style={{ width: 80 }}
                                                                                                                        autoComplete='off'
                                                                                                                        options={combParamsMatricula}
                                                                                                                        selectedKey={cantDiasMatricula.toString()}
                                                                                                                        onChange={(e, i) => {
                                                                                                                            setCantDiasMatricula(parseInt(i!.key.toString()))
                                                                                                                        }}
                                                                                                                    ></ComboBox>
                                                                                                                    :
                                                                                                                    <ComboBox
                                                                                                                        disabled={!i.seleccionado ? true : mesPagoMatricula !== '' ? false : true}
                                                                                                                        defaultChecked
                                                                                                                        style={{ width: 80 }}
                                                                                                                        autoComplete='off'
                                                                                                                        options={listDiasMatricula}
                                                                                                                        selectedKey={cantDiasMatricula.toString()}
                                                                                                                        onChange={(e, i) => {
                                                                                                                            setCantDiasMatricula(parseInt(i!.key.toString()))
                                                                                                                        }}
                                                                                                                    ></ComboBox>
                                                                                                                }
                                                                                                                &nbsp;&nbsp;&nbsp;&nbsp;
                                                                                                                {
                                                                                                                    cantDiasMatricula > 0 ?
                                                                                                                        <u onClick={() => {
                                                                                                                            setVerCuotasMatricula(true)
                                                                                                                        }} style={{ color: '#0062a1', cursor: 'pointer' }} className="text-nowrap" >Ver Cuotas</u>
                                                                                                                        :
                                                                                                                        ""
                                                                                                                }
                                                                                                            </>
                                                                                                    }
                                                                                                </div>
                                                                                                <div>
                                                                                                    <Alert style={{ border: '2px solid #ffffca', fontSize: 10 }}>
                                                                                                        <label className="text-nowrap" style={{ marginTop: 0 }}>{`CUOTAS: Vía canales de pago UDD`}</label>
                                                                                                    </Alert>
                                                                                                </div>
                                                                                            </div>
                                                                                        )
                                                                                    } else if (i.codigoFormaPago === con.codTransferencia() && !esFactura) {
                                                                                        return (
                                                                                            <div style={{ display: 'block' }}>
                                                                                                <FormControlLabel
                                                                                                    control={
                                                                                                        <Checkbox
                                                                                                            checked={i.seleccionado}
                                                                                                            onChange={(e, h) => {
                                                                                                                handleSeleccionMatricula('TRANSFERENCIA BANCARIA', h)
                                                                                                                if (!h) {
                                                                                                                    setValorMatriculaTransferencia(0)
                                                                                                                }
                                                                                                            }}
                                                                                                        />
                                                                                                    }
                                                                                                    label={''}
                                                                                                />
                                                                                                <label style={{ width: '14rem' }} className="text-nowrap">{`${'TRANSFERENCIA BANCARIA'}`}</label>
                                                                                                {
                                                                                                    monedaOriginalMatricula === 1 ?
                                                                                                        ""
                                                                                                        :
                                                                                                        <input
                                                                                                            disabled={true}
                                                                                                            style={{ width: 130, height: 30, border: 1 }}
                                                                                                            value={parseFloat((valorMatriculaTransferencia / (monedaOriginalMatricula === 2 ? paridadUF : paridadDolar)).toFixed(2).toString())}
                                                                                                            type={"number"}>

                                                                                                        </input>
                                                                                                }
                                                                                                <input
                                                                                                    disabled={!i.seleccionado}
                                                                                                    style={{ width: 130, height: 30, border: 1 }}
                                                                                                    value={format(parseInt(valorMatriculaTransferencia.toString()))}
                                                                                                    type={"text"}
                                                                                                    onChange={(o) => {
                                                                                                        if (parseInt(o.target.value.replaceAll('.', '')) >= 0) {
                                                                                                            setValorMatriculaTransferencia(parseInt(o.target.value.replaceAll('.', '')))
                                                                                                        }
                                                                                                    }}
                                                                                                    onBlur={(o) => {
                                                                                                        if (parseInt(o.target.value.replaceAll('.', '')) >= 0) {
                                                                                                            handleIngresarValores(parseInt(o.target.value.replaceAll('.', '')), i.codigoFormaPago, i.codigoItem)
                                                                                                        }
                                                                                                    }}>

                                                                                                </input>
                                                                                                &nbsp;
                                                                                            </div>
                                                                                        )
                                                                                    }
                                                                                })}
                                                                        </FormGroup>
                                                                    </FormControl>
                                                                </Box>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                :
                                                <Alert style={{ width: '15rem' }} variant="outlined"
                                                    iconMapping={{
                                                        info: <CheckCircleOutline fontSize="inherit" />,
                                                    }}
                                                    severity="info">Matrícula Pagada</Alert>
                                        }
                                        {
                                            parseInt(totalFaltanteMatricula.toString()) > 0 ?
                                                <Alert style={{ width: '20rem' }} variant="outlined" severity="warning">{`Faltante $${transformarMiles(totalFaltanteMatricula.toString())}`}</Alert>
                                                :
                                                parseInt(totalFaltanteMatricula.toString()) === 0 ?
                                                    ""
                                                    :
                                                    parseInt(totalFaltanteMatricula.toString()) < 0 && matriculaDetalle!.arancelSaldoFinalCLP > 0 ?
                                                        <Alert style={{ width: '20rem' }} variant="outlined" severity="error">{`Excede $${transformarMiles(totalFaltanteMatricula.toString())}`}</Alert>
                                                        :
                                                        matriculaDetalle!.arancelSaldoFinalCLP < 0 ?
                                                            <div>
                                                                <a>{`Tiene un saldo a favor de `}<strong>{transformarMiles((matriculaDetalle!.arancelSaldoFinalCLP * -1).toString())}</strong>{`, se generará una devolución al finalizar el proceso de mátricula.`}</a>
                                                                <br></br>
                                                                <a>{`Será contactado por el Centro de Atención al Estudiante.`}</a>
                                                            </div>
                                                            : ""
                                        }

                                        {/* ---------------------------------------------------------------------------------------------------------------------------------------- */}

                                    </div>
                                    <div className="payment-selection">
                                        <h3 className="payment-selection__title">Arancel</h3>
                                        <Grid container item xs={12} sm={12} md={12}>
                                            <Grid container item xs={12} sm={6} md={6} direction="column" justifyContent="center" alignItems="stretch">
                                                <DetalleMontoAranceles detalleAranceles={arancelDetalle} className={"payment-selection__table table"}></DetalleMontoAranceles>
                                                {
                                                    arancelDetalle!.arancelSaldoFinalCLP > 0 ?
                                                        <div>
                                                            <h3 className="payment-selection__title ml-2"><small><strong>Formas de pago disponible para Arancel</strong></small></h3>
                                                            <div className="payment-selection__ways ml-2" style={{ display: 'grid' }}>
                                                                {cargandoMultiArancel ?
                                                                    <div className="site-main__container" style={{ backgroundColor: 'rgb(242 247 250)' }}>
                                                                        <div style={{ textAlign: 'center' }}>

                                                                            <CircularProgress disableShrink />
                                                                            <br />
                                                                            <a><span>Cargando datos</span></a>

                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    <div style={{ width: '110%' }}>
                                                                        <table>
                                                                            <thead>
                                                                                <th style={{ width: '17rem' }}></th>
                                                                                {monedaOriginalArancel === 1 ? "" : <th style={{ width: '8rem', textAlign: 'center' }}>{monedaOriginalArancel === 2 ? "UF" : "USD"}</th>}
                                                                                <th style={{ width: '8rem', textAlign: 'center' }}>CLP</th>
                                                                            </thead>
                                                                        </table>
                                                                        <Box sx={{ display: 'flex' }}>
                                                                            <FormControl component="fieldset" variant="standard">
                                                                                <FormGroup>
                                                                                    {
                                                                                        listFormaPagoArancel.map((i: IViewFormaPagoMulti) => {
                                                                                            if (i.nombreFormaPago === 'WebPay') {
                                                                                                return (
                                                                                                    <div>
                                                                                                        <div style={{ display: 'block', width: '130%' }}>
                                                                                                            <FormControlLabel
                                                                                                                control={
                                                                                                                    <Checkbox
                                                                                                                        checked={i.seleccionado}
                                                                                                                        onChange={(e, h) => {
                                                                                                                            handleSeleccionArancel('WebPay', h, 1)
                                                                                                                            if (!h) {
                                                                                                                                setValorArancelWebpay(0)
                                                                                                                            }
                                                                                                                        }}
                                                                                                                    />
                                                                                                                }
                                                                                                                label={''}
                                                                                                            />
                                                                                                            <label style={{ width: '14rem' }} className="text-nowrap">{`WEBPAY`}</label>
                                                                                                            {
                                                                                                                monedaOriginalArancel === 1 ?
                                                                                                                    ""
                                                                                                                    :
                                                                                                                    <input
                                                                                                                        disabled={true}
                                                                                                                        style={{ width: 130, height: 30, border: 1 }}
                                                                                                                        value={(parseFloat((valorArancelWebpay / (monedaOriginalMatricula === 2 ? paridadUF : paridadDolar)).toFixed(2).toString()))}
                                                                                                                        type={"number"}>
                                                                                                                    </input>
                                                                                                            }
                                                                                                            {

                                                                                                                <input
                                                                                                                    disabled={!i.seleccionado}
                                                                                                                    style={{ width: 130, height: 30, border: 1 }}
                                                                                                                    value={format(parseInt(valorArancelWebpay.toString()))}
                                                                                                                    type={"text"}
                                                                                                                    onChange={(o) => {
                                                                                                                        if (parseInt(o.target.value.replaceAll('.', '')) >= 0) {
                                                                                                                            setValorArancelWebpay(parseInt(o.target.value.replaceAll('.', '')))
                                                                                                                        }
                                                                                                                    }}
                                                                                                                    onBlur={(o) => {
                                                                                                                        if (parseInt(o.target.value.replaceAll('.', '')) >= 0) {
                                                                                                                            handleIngresarValores(parseInt(o.target.value.replaceAll('.', '')), i.codigoFormaPago, i.codigoItem)
                                                                                                                        }
                                                                                                                    }}>
                                                                                                                </input>
                                                                                                            }
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )
                                                                                            } else if (i.nombreFormaPago === "CUOTAS" && !esFactura) {
                                                                                                return (
                                                                                                    <div style={{ display: 'inline' }}>
                                                                                                        <div style={{ display: 'flex' }}>
                                                                                                            <FormControlLabel
                                                                                                                control={
                                                                                                                    <Checkbox
                                                                                                                        checked={i.seleccionado}
                                                                                                                        onChange={(e, h) => {
                                                                                                                            handleSeleccionArancel('CUOTAS', h)
                                                                                                                            if (!h) {
                                                                                                                                setValorArancelCuotas(0)
                                                                                                                            }
                                                                                                                        }}
                                                                                                                    />
                                                                                                                }
                                                                                                                label={''}
                                                                                                            />
                                                                                                            <label style={{ width: '14rem', marginTop: 10 }} className="text-nowrap">{`${i.nombreFormaPago}`}</label>
                                                                                                            {
                                                                                                                monedaOriginalArancel === 1 ?
                                                                                                                    ""
                                                                                                                    :
                                                                                                                    <input
                                                                                                                        disabled={true}
                                                                                                                        style={{ width: 130, height: 30, border: 1 }}
                                                                                                                        value={parseFloat((valorArancelCuotas / (monedaOriginalMatricula === 2 ? paridadUF : paridadDolar)).toFixed(2).toString())}
                                                                                                                        type={"number"}>
                                                                                                                    </input>
                                                                                                            }
                                                                                                            <input
                                                                                                                disabled={!i.seleccionado}
                                                                                                                style={{ width: 130, height: 30, border: 1 }}
                                                                                                                value={format(parseInt(valorArancelCuotas.toString()))}
                                                                                                                id="number"
                                                                                                                type={"text"}
                                                                                                                onChange={(o) => {
                                                                                                                    if (parseInt(o.target.value.replaceAll('.', '')) >= 0) {
                                                                                                                        setValorArancelCuotas(parseInt(o.target.value.replaceAll('.', '')))
                                                                                                                    }
                                                                                                                }}
                                                                                                                onBlur={(o) => {
                                                                                                                    if (parseInt(o.target.value.replaceAll('.', '')) >= 0) {
                                                                                                                        handleIngresarValores(parseInt(o.target.value.replaceAll('.', '')), i.codigoFormaPago, i.codigoItem)
                                                                                                                    }
                                                                                                                }}>
                                                                                                            </input>
                                                                                                            &nbsp;
                                                                                                            <label className="text-nowrap" style={{ marginTop: 10 }}></label>&nbsp;&nbsp;&nbsp;&nbsp;
                                                                                                            {
                                                                                                                verCuotasArancel ?
                                                                                                                    <>
                                                                                                                        <label className="text-nowrap" style={{ marginTop: 10 }}>{listFormaPagoArancel.map((e: IViewFormaPagoMulti) => {
                                                                                                                            if (monedaOriginalArancel !== 1) {
                                                                                                                                if (e.nombreFormaPago === "CUOTAS" && cantDiasArancel > 0) {
                                                                                                                                    return (
                                                                                                                                        <p>{`${codNegocio === 1 ? e.cuotasMaximo : e.cantCuotas} Cuotas de un valor de ${parseFloat((e.montoUF / (codNegocio === 1 ? e.cuotasMaximo : e.cantCuotas)).toString()).toFixed(2)} `}{monedaOriginalArancel === 2 ? 'UF' : 'USD'}</p>
                                                                                                                                    )
                                                                                                                                }
                                                                                                                            } else {
                                                                                                                                if (e.nombreFormaPago === "CUOTAS" && cantDiasArancel > 0) {
                                                                                                                                    return (
                                                                                                                                        <p>{e.nombreFormaPago === "CUOTAS" ? `${codNegocio === 1 ? e.cuotasMaximo : e.cantCuotas} Cuotas de un valor de $${transformarMiles((e.montoCLP / (codNegocio === 1 ? e.cuotasMaximo : e.cantCuotas)).toString())} ` : `$${transformarMiles(e.montoCLP.toString())}`}</p>
                                                                                                                                    )
                                                                                                                                }
                                                                                                                            }
                                                                                                                        })}</label>  &nbsp;&nbsp;
                                                                                                                        <u onClick={() => {
                                                                                                                            setVerCuotasArancel(false)
                                                                                                                        }} className="text-nowrap" style={{ color: '#0062a1', cursor: 'pointer', marginTop: '0.5rem' }} >Cambiar fecha de pago</u>
                                                                                                                    </>
                                                                                                                    :
                                                                                                                    <>
                                                                                                                        {
                                                                                                                            codNegocio === 1 ?
                                                                                                                                ""
                                                                                                                                :
                                                                                                                                <>
                                                                                                                                    <label className="text-nowrap" style={{ marginTop: 10 }}>{`Mes de inicio de pago `}</label>&nbsp;&nbsp;
                                                                                                                                    <ComboBox
                                                                                                                                        disabled={!i.seleccionado}
                                                                                                                                        defaultChecked
                                                                                                                                        style={{ width: '10rem' }}
                                                                                                                                        autoComplete='off'
                                                                                                                                        options={combMesesArancel}
                                                                                                                                        selectedKey={mesPagoArancel}
                                                                                                                                        onChange={(e, i) => {
                                                                                                                                            onSelectMes(i!.key.toString());
                                                                                                                                            setMesPagoArancel(i!.key.toString())
                                                                                                                                            /* console.log(i!.key.toString()) */
                                                                                                                                        }}

                                                                                                                                    ></ComboBox>&nbsp;&nbsp;&nbsp;&nbsp;
                                                                                                                                </>
                                                                                                                        }
                                                                                                                        &nbsp;&nbsp;
                                                                                                                        <label className="text-nowrap" style={{ marginTop: 10 }}>{`Día de pago`}</label> &nbsp;&nbsp;
                                                                                                                        {codNegocio === 1 ?
                                                                                                                            tienePACPAT ?
                                                                                                                                <span className='diaPago'>{cantDiasArancel}</span> :
                                                                                                                                <ComboBox
                                                                                                                                    disabled={!i.seleccionado}
                                                                                                                                    defaultChecked
                                                                                                                                    style={{ width: 80 }}
                                                                                                                                    autoComplete='off'
                                                                                                                                    options={combParamsArancel}
                                                                                                                                    onChange={(e, i) => {
                                                                                                                                        setCantDiasArancel(parseInt(i?.key.toString() || '0'));
                                                                                                                                    }}
                                                                                                                                    selectedKey={cantDiasArancel.toString()}
                                                                                                                                ></ComboBox>
                                                                                                                            :
                                                                                                                            <ComboBox
                                                                                                                                disabled={!i.seleccionado ? true : mesPagoArancel !== '' ? false : true}
                                                                                                                                defaultChecked
                                                                                                                                style={{ width: 80 }}
                                                                                                                                autoComplete='off'
                                                                                                                                options={listDiasArancel}
                                                                                                                                selectedKey={cantDiasArancel.toString()}
                                                                                                                                onChange={(e, i) => {
                                                                                                                                    setCantDiasArancel(parseInt(i!.key.toString()))
                                                                                                                                }}
                                                                                                                            ></ComboBox>
                                                                                                                        }
                                                                                                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                                                                                                        {
                                                                                                                            cantDiasArancel > 0 ?
                                                                                                                                <u onClick={() => {
                                                                                                                                    setVerCuotasArancel(true)
                                                                                                                                }} style={{ color: '#0062a1', cursor: 'pointer' }} className="text-nowrap" >Ver Cuotas</u>
                                                                                                                                :
                                                                                                                                ""
                                                                                                                        }
                                                                                                                    </>
                                                                                                            }
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            <Alert style={{ border: '2px solid #ffffca', fontSize: 10 }}>
                                                                                                                <label className="text-nowrap" style={{ marginTop: 0 }}>{`CUOTAS: Vía canales de pago UDD`}</label>
                                                                                                            </Alert>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                )
                                                                                            } else if (i.codigoFormaPago === con.codTransferencia() && !esFactura) {
                                                                                                return (
                                                                                                    <div style={{ display: 'block' }}>
                                                                                                        <FormControlLabel
                                                                                                            control={
                                                                                                                <Checkbox
                                                                                                                    checked={i.seleccionado}
                                                                                                                    onChange={(e, h) => {
                                                                                                                        handleSeleccionArancel('TRANSFERENCIA BANCARIA', h)
                                                                                                                        if (!h) {
                                                                                                                            setValorArancelTransferencia(0)
                                                                                                                        }
                                                                                                                    }}
                                                                                                                />
                                                                                                            }
                                                                                                            label={''}
                                                                                                        />
                                                                                                        <label style={{ width: '14rem' }} className="text-nowrap">{`${i.nombreFormaPago}`}</label>
                                                                                                        {
                                                                                                            monedaOriginalArancel === 1 ?
                                                                                                                ""
                                                                                                                :
                                                                                                                <input
                                                                                                                    disabled={true}
                                                                                                                    style={{ width: 130, height: 30, border: 1 }}
                                                                                                                    value={parseFloat((valorArancelTransferencia / (monedaOriginalMatricula === 2 ? paridadUF : paridadDolar)).toFixed(2).toString())}
                                                                                                                    type={"number"}>
                                                                                                                </input>
                                                                                                        }
                                                                                                        {
                                                                                                            <input
                                                                                                                disabled={!i.seleccionado}
                                                                                                                style={{ width: 130, height: 30, border: 1 }}
                                                                                                                value={format(parseInt(valorArancelTransferencia.toString()))}
                                                                                                                type={"text"}
                                                                                                                onChange={(o) => {
                                                                                                                    if (parseInt(o.target.value.replaceAll('.', '')) >= 0) {
                                                                                                                        setValorArancelTransferencia(parseInt(o.target.value.replaceAll('.', '')))
                                                                                                                    }
                                                                                                                }}
                                                                                                                onBlur={(o) => {
                                                                                                                    if (parseInt(o.target.value.replaceAll('.', '')) >= 0) {
                                                                                                                        handleIngresarValores(parseInt(o.target.value.replaceAll('.', '')), i.codigoFormaPago, i.codigoItem)
                                                                                                                    }
                                                                                                                }}>

                                                                                                            </input>
                                                                                                        }

                                                                                                        &nbsp;
                                                                                                    </div>
                                                                                                )
                                                                                            }
                                                                                        })}
                                                                                </FormGroup>
                                                                            </FormControl>
                                                                        </Box>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        :
                                                        <Alert style={{ width: '15rem' }}
                                                            variant="outlined"
                                                            /* icon={<CheckIcon fontSize="inherit" />} */
                                                            iconMapping={{
                                                                info: <CheckCircleOutline fontSize="inherit" />,
                                                            }}
                                                            severity="info">
                                                            Arancel Pagado</Alert>
                                                }
                                                {
                                                    parseInt(totalFaltanteArancel.toString()) > 0 ?
                                                        <Alert style={{ width: '20rem' }} variant="outlined" severity="warning">{`Faltante $${transformarMiles(totalFaltanteArancel.toString())}`}</Alert>
                                                        :
                                                        parseInt(totalFaltanteArancel.toString()) === 0 ?
                                                            ""
                                                            :
                                                            parseInt(totalFaltanteArancel.toString()) < 0 && arancelDetalle!.arancelSaldoFinalCLP > 0 ?
                                                                <Alert style={{ width: '20rem' }} variant="outlined" severity="error">{`Excede $${transformarMiles(totalFaltanteArancel.toString())}`}</Alert>
                                                                :
                                                                arancelDetalle!.arancelSaldoFinalCLP < 0 ?
                                                                    <div>
                                                                        <a>{`Tiene un saldo a favor de `}<strong>{transformarMiles((arancelDetalle!.arancelSaldoFinalCLP * -1).toString())}</strong>{`, se generará una devolución al finalizar el proceso de mátricula.`}</a>
                                                                        <br></br>
                                                                        <a>{`Será contactado por el Centro de Atención al Estudiante.`}</a>
                                                                    </div>
                                                                    :
                                                                    ""
                                                }
                                                {/* ------------------------------------------------------------------------------------------------------------------------ */}
                                            </Grid>
                                            {
                                                <Grid container item xs={12} sm={12} md={6} direction="column" alignItems="stretch" alignContent="center">
                                                    {
                                                        tienecomplementario ?
                                                            <div style={{ /* whiteSpace: 'nowrap' */ }} className="ml-2 mt-3" >
                                                                {
                                                                    /* beneficioComplementarioSelec !== '' || beneficioComplementarioSelec !== null || beneficioComplementarioSelec !== undefined ?
                                                                        ""
                                                                        : */
                                                                    <div>
                                                                        <p style={{ fontSize: '1rem' }}>Tu beca tiene beneficios complementarios, debes seleccionar el que prefieras:</p>
                                                                        <Button style={{ border: '1px solid #2196f3', width: '100%', fontSize: '1rem' }} onClick={() => setModalBeneficios(true)} className="mt-0">Selecciona beneficio complementario</Button>
                                                                    </div>
                                                                }
                                                            </div>
                                                            :
                                                            ""
                                                    }
                                                    {
                                                        beneficioComplementarioSelec !== '' && beneficioComplementarioSelec !== null && beneficioComplementarioSelec !== undefined ?
                                                            <div>
                                                                <br />
                                                                <Alert
                                                                    variant="outlined"
                                                                    style={{ fontSize: '1rem' }}
                                                                    /* icon={<CheckIcon fontSize="inherit" />} */
                                                                    iconMapping={{
                                                                        info: <CheckCircleOutline fontSize="inherit" />,
                                                                    }}
                                                                    severity="info">
                                                                    Beneficio Complementario '{beneficioComplementarioSelec}'.
                                                                </Alert>
                                                            </div>
                                                            :
                                                            ""
                                                    }
                                                    {
                                                        teniaCAE ?
                                                            <div className="ml-2 mt-3">
                                                                {tienecomplementario ? <Divider className="mb-3" /> : ""}
                                                                <p style={{ fontSize: '1rem' }}>¿ Usarás CAE ?</p>
                                                                <Button style={quiereCAE ? { width: '2rem', border: '1px solid #0062a1', color: 'white', backgroundColor: '#0062a1', fontSize: '1rem' } : { width: '2rem', border: '1px solid gray', fontSize: '1rem' }} /* disabled={quiereCAE} */ onClick={() => setOpenCAEAceptar(true)}>Si</Button>&nbsp;
                                                                <Button style={!quiereCAE ? { width: '2rem', border: '1px solid #0062a1', color: 'white', backgroundColor: '#0062a1', fontSize: '1rem' } : { width: '2rem', border: '1px solid gray', fontSize: '1rem' }} /* disabled={!quiereCAE} */ onClick={() => setOpenCAERechazar(true)}>No</Button>&nbsp;
                                                            </div>
                                                            :
                                                            ""
                                                    }
                                                </Grid>
                                            }
                                        </Grid>
                                    </div>

                                    {arancelCuotas && visualizarPACPAT ?
                                        <div className="payment-selection" style={{ paddingTop: 20, paddingLeft: 50 }}>
                                            <Grid container item xs={12} sm={12} md={12} direction="column" justifyContent="center">
                                                {
                                                    <div style={{ marginTop: -5 }}>
                                                        <Divider />
                                                        {
                                                            !esNuevo ?
                                                                <p style={{ fontSize: '1rem', border: '1px solid orange', padding: 5 }}>Si tiene ya cuenta con PAC/PAT no es necesario volver a solicitarlo.</p>
                                                                :
                                                                ""
                                                        }
                                                        <p style={{ fontSize: '1rem' }}>Si quieres suscribir convenio PAC o PAT selecciona acá:</p>
                                                        <Button style={PP === 'PAC' ? { border: '1px solid #0062a1', color: 'white', backgroundColor: '#0062a1', fontSize: '1rem' } : { border: '1px solid gray', fontSize: '1rem' }} /* disabled={PP === 'PAC' ? true : false} */ onClick={() => {
                                                            setPP('PAC')
                                                            AgregarPAC()
                                                        }}>Convenio PAC</Button>&nbsp;
                                                        <Button style={PP === 'PAT' ? { border: '1px solid #0062a1', color: 'white', backgroundColor: '#0062a1', fontSize: '1rem' } : { border: '1px solid gray', fontSize: '1rem' }} /* disabled={PP === 'PAT' ? true : false} */ onClick={() => {
                                                            setPP('PAT')
                                                            AgregarPAT()
                                                        }}>Convenio PAT</Button>&nbsp;
                                                        <Button style={PP === '' || PP === null || PP === undefined ? { border: '1px solid #0062a1', color: 'white', backgroundColor: '#0062a1', fontSize: '1rem' } : { border: '1px solid gray', fontSize: '1rem' }} /* disabled={PP === '' || PP === null || PP === undefined ? true : false} */ onClick={() => {
                                                            setPP('')
                                                            EliminarPACPAT()
                                                        }}>X</Button>
                                                        {
                                                            PP === 'PAT' || PP === 'PAC' ?
                                                                <div>
                                                                    <br />
                                                                    <Alert
                                                                        variant="outlined"
                                                                        style={{ fontSize: '1rem' }}
                                                                        /* icon={<CheckIcon fontSize="inherit" />} */
                                                                        iconMapping={{
                                                                            info: <CheckCircleOutline fontSize="inherit" />,
                                                                        }}
                                                                        severity="info">
                                                                        Hemos registrado su solicitud. En el transcurso de 24 horas enviaremos un link para que puedas suscribir tu mandato de pago automático.
                                                                        {/* Hemos registrado su solicitud. Nos contactaremos con usted para coordinar la firma del convenio respectivo. */}
                                                                    </Alert>
                                                                </div>
                                                                :
                                                                ""
                                                        }
                                                    </div>
                                                }
                                            </Grid>
                                        </div>
                                        :
                                        ""
                                    }

                                    <div className="payment-webpay__submit">
                                        <div className="form-group">
                                            {
                                                codNegocio === 1 || codNegocio === 2 ?
                                                    <a onClick={() => { onClickContinuar("1") }} style={{ cursor: 'pointer' }} className="enrollment__back"><svg className="svg-chevron-left-dims"><use xlinkHref={d1 + "#chevron-left"}></use></svg> Volver a Datos Personales</a>
                                                    :
                                                    ""
                                            }
                                            <br></br>
                                            {
                                                errorGuardarFP ?
                                                    <Alert severity="error">Ocurrió un problema al intentar guardar las formas de pago, reintente nuevamente.</Alert>
                                                    :
                                                    ""
                                            }
                                            &nbsp;&nbsp;&nbsp;<label className="submit-btn__label-disabled">
                                                {debeFirmar ? "Ir a Pago" : (totalFaltanteArancel <= 0 && totalFaltanteMatricula <= 0 ? "Finalizar proceso" : "Ir a Pago")}
                                            </label>
                                            <p data-type={'light'} data-tip={
                                                !(arancelPagada || arancelSeleccionada) && totalFaltanteArancel > 0 ? "Arancel no seleccionada" :
                                                    !(matriculaPagada || matriculaSeleccionada) && totalFaltanteMatricula > 0 ? "Matrícula no seleccionada" : ""
                                            }>
                                                <button onClick={() => {
                                                    setGuardar(true)
                                                    setOpenModalFormasPago(true)
                                                    handleDatosFacturacioncompletos()
                                                }} id="payment-submit__button" disabled={((matriculaDetalle!.arancelSaldoFinalCLP > 0 ? (matriculaPagada || matriculaSeleccionada) : true) && (!cargando) && (valorMatriculaCuotas > 0 ? (cantDiasMatricula > 0 ? cuotaMatricula > 0 : false) : true) && (valorArancelCuotas > 0 ? (cantDiasArancel > 0 ? cuotaArancel > 0 : false) : true) && (arancelDetalle!.arancelSaldoFinalCLP > 0 ? (arancelPagada || arancelSeleccionada) : true) && parseInt(totalFaltanteArancel.toString()) <= 0 && parseInt(totalFaltanteMatricula.toString()) <= 0 && (tienecomplementario ? beneficioComplementarioSelec === '' || beneficioComplementarioSelec === null || beneficioComplementarioSelec === undefined ? false : true : true) === true) ? false : true} className="btn btn-primary js-needs-confirmation" type="submit">{cargando ? "Procesando" : "Continuar"}</button>
                                                <ReactTooltip /></p>
                                        </div>
                                    </div>
                                </div>}
                            <BeneficioComplementario nameBeneficio={beneficioComplementarioSelec} idClienteC={beneficioComplementarioID} idBeneficioC={idBeneficio} beneficiosC={beneficios} callback={beneficioNombre/* setModalBeneficios(false) */} estado={modalBeneficios}></BeneficioComplementario>
                        </main >}

            <Dialog open={openCondiciones}
                onClose={() => setOpenCondiciones(false)}

                aria-labelledby="draggable-dialog-title">
                <DialogContent>
                    <div style={{ fontFamily: 'sans-serif', textAlign: 'center', height: '100%' }}>
                        <div className='declaracion2'>
                            {parse(_xml)}
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button style={{ width: '5rem', border: '1px solid gray', backgroundColor: '#009cff', color: 'white' }} onClick={() => {
                        setOpenCondiciones(false)
                    }}>Cerrar</Button>&nbsp;
                </DialogActions>
            </Dialog>

            <Dialog
                open={dialogFP}
                keepMounted
                onClose={() => setDialogFP(false)}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>¿Esta seguro que desea cambiar la forma de pago a {!esFactura ? "Factura" : "Boleta"}?</DialogTitle>
                <DialogContent>
                    {esFactura ?
                        <DialogContentText id="alert-dialog-slide-description">
                            La forma de pago factura solo permite pagar con WebPay.
                        </DialogContentText> : ""
                    }
                </DialogContent>
                <DialogActions>
                    <Button style={{ width: '5rem', border: '1px solid gray', backgroundColor: '#009cff', color: 'white' }} onClick={() => {
                        setDialogFP(false); cambiarFP(formaPagoFP); setChkFacturarDatosAlumno(false);
                    }}>Aceptar
                    </Button>
                    <Button style={{ width: '5rem', border: '1px solid gray', backgroundColor: '#009cff', color: 'white' }} onClick={() => {
                        setDialogFP(false)
                    }}>Cerrar
                    </Button>&nbsp;
                </DialogActions>
            </Dialog>


            <Dialog
                open={dialogFacturacion}
                keepMounted
                onClose={() => setDialogFP(false)}
                aria-describedby="alert-dialog-slide-description"
                maxWidth="lg"
            >
                <DialogTitle>INGRESO DE DATOS DE FACTURACIÓN</DialogTitle>
                <DialogContent>

                    <DialogContentText id="alert-dialog-slide-description" style={{ width: 800 }}>
                        <div style={{ position: 'absolute', top: 15, right: 5 }}>
                            <Button id="Cerrar" style={{ width: '1rem', border: '0px solid gray', backgroundColor: '#FFFFFF', color: 'black', fontWeight: 'bold' }} onClick={() => { setdialogFacturacion(false); setMostrarDatosFacturacion(true); handleCerrar() }}> X </Button>
                        </div>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={ChkFacturarDatosAlumno}
                                    onChange={(e, h) => {
                                        handleFacturarDatosAlumno(h)
                                    }}
                                    disabled={false}
                                />
                            }
                            label={<div className="enrollment__subtitle"><a>¿Facturar con mis datos?</a></div>}
                        />
                        <br />
                        <label style={{ width: '12rem' }} className="text-nowrap">{`Rut`}</label>
                        <label style={{ width: '1rem', color: 'red' }} className="text-nowrap">{`*`}</label>
                        <input
                            id="_RutFacturacion"
                            name='Rut'
                            defaultValue={""}
                            type="text"
                            value={RutFacturacion}
                            maxLength={13}
                            placeholder={'99.999.999-9'}
                            required
                            disabled={ChkFacturarDatosAlumno}
                            onBlur={(e) => handleValidaRut(e.target.value.trim())}
                            onChange={(e) => setRutFacturacion(formatterRut(e.target.value.trim()))}

                        />

                        <br />
                        {ChkFacturarDatosAlumno == true ?
                            <div style={{ padding: 0 }}>
                                <label style={{ width: '12rem' }} className="text-nowrap">{`Nombres y Apellidos`}</label>
                                <label style={{ width: '1rem', color: 'red' }} className="text-nowrap">{`*`}</label>
                                <input
                                    disabled={ChkFacturarDatosAlumno}
                                    style={{ width: 500, height: 30, border: '1px solid lightgray' }}
                                    value={NombreFacturacion}
                                    type={"text"}
                                >
                                </input>
                            </div>
                            :
                            <div>
                                <label style={{ width: '12rem' }} className="text-nowrap">{`Razón social`}</label>
                                <label style={{ width: '1rem', color: 'red' }} className="text-nowrap">{`*`}</label>
                                <input
                                    disabled={!DatosEmpresaNueva && !ChkFacturarDatosAlumno}
                                    style={{ width: 500, height: 30, border: '1px solid lightgray' }}
                                    value={RazonSocial}
                                    onChange={(e) => setRazonSocial(e.target.value)}
                                    type={"text"}>
                                </input>
                            </div>
                        }
                        <label style={{ width: '12rem' }} className="text-nowrap">{`Correo envío factura`}</label>
                        <label style={{ width: '1rem', color: 'red' }} className="text-nowrap">{`*`}</label>
                        <input
                            style={{ width: 500, height: 30, border: '1px solid lightgray' }}
                            value={CorreoFacturacion}
                            onChange={(e) => setCorreoFacturacion(e.target.value)}
                            type={"text"}
                        >

                        </input>
                        <br />
                        <label style={{ width: '11rem' }} className="text-nowrap">{`Teléfono`}</label>
                        <label style={{ width: '2rem' }} className="text-nowrap">{`+56`}</label>
                        <input
                            //
                            style={{ width: 500, height: 30, border: '1px solid lightgray' }}
                            value={Telefono}
                            onChange={(e) => setTelefono(e.target.value)}
                            onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                            maxLength={9}
                            type="text"
                        >
                        </input>
                        <br />
                        <label style={{ width: '12rem' }} className="text-nowrap">{`Dirección`}</label>
                        <label style={{ width: '1rem', color: 'red' }} className="text-nowrap">{`*`}</label>
                        <input
                            disabled={!DatosEmpresaNueva && !ChkFacturarDatosAlumno}
                            style={{ width: 500, height: 30, border: '1px solid lightgray' }}
                            value={Direccion}
                            onChange={(e) => setDireccion(e.target.value)}
                            type={"text"}>
                        </input>
                        <br />
                        <label style={{ width: '12rem' }} className="text-nowrap">{`Giro`}</label>
                        <label style={{ width: '1rem', color: 'red' }} className="text-nowrap">{`*`}</label>
                        <input
                            disabled={!DatosEmpresaNueva && !ChkFacturarDatosAlumno}
                            style={{ width: 500, height: 30, border: '1px solid lightgray' }}
                            value={Giro}
                            onChange={(e) => setGiro(e.target.value)}
                            type={"text"}>
                        </input>
                        <br />
                        <label style={{ width: '12rem' }} className="text-nowrap">{`Comuna`}</label>
                        <label style={{ width: '1rem', color: 'red' }} className="text-nowrap">{`*`}</label>
                        <Autocomplete id="lstComuna"
                            disabled={!ChkFacturarDatosAlumno && !DatosEmpresaNueva}
                            value={valComuna}
                            style={{ marginTop: -35, marginLeft: '13rem', width: '31.3rem' }}
                            options={listaComunas}
                            noOptionsText={'No existe la opción.'}
                            getOptionLabel={(options: {
                                ID: number;
                                descripcion: string;
                            }) => toUpperCamelCase(options.descripcion)}
                            onChange={handleSelectComuna}
                            renderInput={params => (
                                <TextField
                                    {...params}
                                    placeholder="Seleccione comuna"
                                    label=""
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'new-password',
                                    }}
                                />
                            )}
                        />
                        <label className="text-nowrap">{'(*) Datos obligatorios'}</label>
                        <DialogTitle>
                            <label style={{ color: 'red' }} className="text-nowrap">{ErrorFacturacion}</label>
                        </DialogTitle>

                    </DialogContentText>

                </DialogContent>
                <DialogActions>

                    <div>{ErrorFacturacion !== '' ?
                        <Button
                            style={{ width: '6rem', border: '1px solid gray', backgroundColor: 'green', color: 'white', marginRight: 10, }}
                            onClick={handleValidarDatos}
                            disabled={DisableBotonIngresar ? true : false}
                        >Guardar</Button>
                        :
                        <Button
                            style={{ width: '6rem', border: '1px solid gray', backgroundColor: 'green', color: 'white', marginRight: 10 }}
                            onClick={handleValidarDatos}
                            disabled={DisableBotonIngresar ? true : false}
                        >Guardar</Button>
                    }
                        <Button style={{ width: '6rem', border: '1px solid gray', backgroundColor: '#009cff', color: 'white' }}
                            onClick={handleLimpiarFacturacion}>Limpiar</Button>
                    </div>

                </DialogActions>
            </Dialog>
            <Dialog open={openCAERechazar}
                onClose={() => setOpenCAERechazar(false)}

                aria-labelledby="draggable-dialog-title">
                <DialogContent>
                    <div style={{ fontFamily: 'sans-serif', textAlign: 'center', height: '100%' }}>
                        ¿ Esta seguro de no querer CAE ?
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button style={{ width: '3rem', border: '1px solid gray' }} onClick={() => {
                        setQuiereCAE(false)
                        buscarMontoBeneficio(false)
                        setOpenCAERechazar(false)
                    }}>Si</Button>&nbsp;
                    <Button style={{ width: '3rem', border: '1px solid gray' }} onClick={() => {
                        setOpenCAERechazar(false)
                    }}>No</Button>&nbsp;
                </DialogActions>
            </Dialog>
            <Dialog open={openCantDias}
                onClose={() => setOpenCantDias(false)}

                aria-labelledby="draggable-dialog-title">
                <DialogContent>
                    <div style={{ fontFamily: 'sans-serif', textAlign: 'center', height: '100%' }}>
                        Se ha modificado el pago de cuotas automaticamente al día 30 por vencimiento en el día seleccionado.
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button style={{ width: '5rem', border: '1px solid gray', backgroundColor: '#009cff', color: 'white' }} onClick={() => {
                        setOpenCantDias(false)
                    }}>Aceptar</Button>&nbsp;
                </DialogActions>
            </Dialog>
            <Dialog open={openCAEAceptar}
                onClose={() => setOpenCAEAceptar(false)}

                aria-labelledby="draggable-dialog-title">
                <DialogContent>
                    <div style={{ fontFamily: 'sans-serif', textAlign: 'center', height: '100%' }}>
                        ¿ Esta seguro de querer CAE ?
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button style={{ width: '3rem', border: '1px solid gray' }} onClick={() => {
                        setQuiereCAE(true)
                        buscarMontoBeneficio(true)
                        setOpenCAEAceptar(false)
                    }}>Si</Button>&nbsp;
                    <Button style={{ width: '3rem', border: '1px solid gray' }} onClick={() => {
                        setOpenCAEAceptar(false)
                    }}>No</Button>&nbsp;
                </DialogActions>
            </Dialog>

            <Dialog open={openModalFormasPago}
                onClose={() => setOpenModalFormasPago(false)}
                fullWidth={true}
                aria-labelledby="draggable-dialog-title"
                maxWidth="md"
            >
                <DialogContent>
                    <div style={{ textAlign: 'left', padding: 50 }}>
                        <h2 style={{ textAlign: 'center' }}>Resumen</h2>
                        <br />
                        <Grid container spacing={0} item xs={12} sm={12} md={12} xl={12}>
                            <Grid item xs={12} sm={12} md={12} xl={12}>
                                <>
                                    <h5><span>VALOR MATRÍCULA</span></h5>
                                    <br></br>
                                    {
                                        listFormaPagoMatricula.filter((e: IViewFormaPagoMulti) => e.seleccionado && e.nombreFormaPago != "COMP FACTURACIÓN" && e.montoCLP > 0).length > 0 ?
                                            "" :
                                            <CheckCircleOutline
                                                style={{ color: '#0062a1', fontSize: 30 }}
                                            />
                                    }
                                    {
                                        listFormaPagoMatricula.map((e: IViewFormaPagoMulti) => {
                                            if (e.seleccionado && e.nombreFormaPago != "COMP FACTURACIÓN") {
                                                if (e.montoCLP > 0) {
                                                    return (
                                                        <>
                                                            {
                                                                e.nombreFormaPago === "TRANSFERENCIA BANCARIA" ?
                                                                    <p style={{ textTransform: 'uppercase' }}>{`FORMA DE PAGO: `}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{e.nombreFormaPago}</p>
                                                                    :
                                                                    <p style={{ textTransform: 'uppercase' }}>{`FORMA DE PAGO: `}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{e.nombreFormaPago}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                                                            }

                                                            <Grid container spacing={0} item xs={12} sm={12} md={12} xl={12}>
                                                                <Grid item xs={12} sm={12} md={12} xl={12}>
                                                                    {
                                                                        monedaOriginalMatricula !== 1 ?
                                                                            e.nombreFormaPago === "CUOTAS" ?
                                                                                <p style={{ marginBottom: '2rem' }}>MONTO:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`${codNegocio === 1 ? e.cuotasMaximo : e.cantCuotas} Cuotas de ${parseFloat((e.montoUF / (codNegocio === 1 ? e.cuotasMaximo : e.cantCuotas)).toString()).toFixed(2)} `}{monedaOriginalMatricula === 2 ? 'UF' : 'USD'}</p>
                                                                                :
                                                                                <p style={{ marginBottom: '2rem' }}>MONTO:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{` ${(e.montoUF).toFixed(2).toString()} UF = ${transformarMiles(e.montoCLP.toString())} CLP`}</p>

                                                                            :
                                                                            <p style={{ marginBottom: '2rem' }}>MONTO:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{e.nombreFormaPago === "CUOTAS" ? `${codNegocio === 1 ? e.cuotasMaximo : e.cantCuotas} Cuotas de $${transformarMiles((e.montoCLP / (codNegocio === 1 ? e.cuotasMaximo : e.cantCuotas)).toString())} ` : `$${transformarMiles(e.montoCLP.toString())}`}</p>
                                                                    }

                                                                </Grid>
                                                            </Grid>
                                                        </>
                                                    )
                                                }
                                            }
                                        })
                                    }
                                    <br></br>
                                    <br></br>
                                </>
                                <>
                                    <h5 style={{ marginTop: '1rem' }}><span>VALOR ARANCEL</span></h5>
                                    <br></br>
                                    {
                                        listFormaPagoArancel.filter((e: IViewFormaPagoMulti) => e.seleccionado && e.nombreFormaPago != "COMP FACTURACIÓN" && e.montoCLP > 0).length > 0 ?
                                            "" :
                                            <CheckCircleOutline
                                                style={{ color: '#0062a1', fontSize: 30 }}
                                            />
                                    }
                                    {
                                        listFormaPagoArancel.map((e: IViewFormaPagoMulti) => {
                                            if (e.seleccionado && e.nombreFormaPago != "COMP FACTURACIÓN") {
                                                if (e.montoCLP > 0) {
                                                    return (
                                                        <>
                                                            {
                                                                e.nombreFormaPago === "TRANSFERENCIA BANCARIA" ?
                                                                    <p style={{ textTransform: 'uppercase' }}>{`FORMA DE PAGO: `}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{e.nombreFormaPago}</p>
                                                                    :
                                                                    <p style={{ textTransform: 'uppercase' }}>{`FORMA DE PAGO: `}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{e.nombreFormaPago}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                                                            }

                                                            <Grid container spacing={0} item xs={12} sm={12} md={12} xl={12}>

                                                                <Grid item xs={12} sm={12} md={12} xl={12}>
                                                                    {
                                                                        monedaOriginalMatricula !== 1 ?
                                                                            e.nombreFormaPago === "CUOTAS" ?
                                                                                <p style={{ marginBottom: '2rem' }}>MONTO:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`${codNegocio === 1 ? e.cuotasMaximo : e.cantCuotas} Cuotas de ${parseFloat((e.montoUF / (codNegocio === 1 ? e.cuotasMaximo : e.cantCuotas)).toString()).toFixed(2)} `}{monedaOriginalArancel === 2 ? 'UF' : 'USD'}</p>
                                                                                :
                                                                                <p style={{ marginBottom: '2rem' }}>MONTO:&nbsp;{` ${parseFloat(e.montoUF.toString()).toFixed(2)} UF = ${transformarMiles(e.montoCLP.toString())} CLP`}</p>
                                                                            :
                                                                            <p style={{ marginBottom: '2rem' }}>MONTO:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{e.nombreFormaPago === "CUOTAS" ? `${codNegocio === 1 ? e.cuotasMaximo : e.cantCuotas} Cuotas de $${transformarMiles((e.montoCLP / (codNegocio === 1 ? e.cuotasMaximo : e.cantCuotas)).toString())} ` : `$${transformarMiles(e.montoCLP.toString())}`}</p>
                                                                    }

                                                                </Grid>
                                                            </Grid>
                                                        </>
                                                    )
                                                }
                                            }
                                        })
                                    }
                                    <br></br>
                                    <br></br>
                                    {monedaOriginalArancel > 1 ?
                                        <a style={{ fontSize: 12, color: 'gray' }}>*MONTO CLP CALCULADO AL VALOR {monedaOriginalArancel === 2 ? 'UF' : 'USD'} DEL DÍA: {HandleFormatFecha2(fechaParidad !== '' ? fechaParidad : new Date().toString())}</a>
                                        :
                                        ""}
                                </>
                            </Grid>
                            <Grid item xs={12}>
                                {MostrarDatosFacturacion ?
                                    <div className="payment-selection" style={{ padding: "5px 50px" }}>
                                        <DialogContent style={{ padding: 0, overflow: "hidden" }}>
                                            <h5><span>DATOS FACTURACIÓN</span></h5>
                                            <Grid container spacing={1} style={{ margin: 0, padding: 0 }} >
                                                <Grid item xs={12} sm={12} md={12} xl={12}>
                                                    <label style={{ width: '12rem' }} className="text-nowrap">{`Rut`}</label>:
                                                    <label style={{ width: '12rem' }} className="text-nowrap">{RutFacturacion}</label>
                                                    <br />
                                                    {ChkFacturarDatosAlumno == true ?
                                                        <div>
                                                            <label style={{ width: '12rem' }} className="text-nowrap">{`Nombre`}</label>:
                                                            <label style={{ width: '12rem' }} className="text-nowrap">{NombreFacturacion}</label>
                                                        </div>
                                                        :
                                                        <div>
                                                            <label style={{ width: '12rem' }} className="text-nowrap">{`Nombre Empresa`}</label>:
                                                            <label style={{ width: '12rem' }} className="text-nowrap">{RazonSocial}</label>
                                                        </div>
                                                    }
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} xl={12}>
                                                    <label style={{ width: '12rem' }} className="text-nowrap">{`Correo envío factura`}</label>:
                                                    <label style={{ width: '12rem' }} className="text-nowrap">{CorreoFacturacion}</label>
                                                    <br />
                                                    <label style={{ width: '12rem' }} className="text-nowrap">{`Teléfono`}</label>:
                                                    <label style={{ width: '12rem' }} className="text-nowrap">{Telefono}</label>
                                                    <br />
                                                    <label style={{ width: '12rem' }} className="text-nowrap">{`Dirección`}</label>:
                                                    <label style={{ width: '12rem' }} className="text-nowrap">{Direccion}</label>
                                                    <br />
                                                    <label style={{ width: '12rem' }} className="text-nowrap">{`Giro`}</label>:
                                                    <label style={{ width: '12rem' }} className="text-nowrap">{Giro}</label>
                                                    <br />
                                                    <label style={{ width: '12rem' }} className="text-nowrap">{`Comuna`}</label>:
                                                    <label style={{ width: '12rem' }} className="text-nowrap">{NombreComuna}</label>
                                                    <br />
                                                    <br />
                                                </Grid>
                                            </Grid>
                                        </DialogContent>
                                    </div>
                                    :
                                    <div></div>
                                }
                            </Grid>
                        </Grid>
                    </div>
                    {formaPagoFP == 2 ?
                        <label style={{ width: '12rem', color: 'red' }} className="text-nowrap">{!DatosFacturacionGuardados ? '* Debe ingresar datos de facturación' : ''}</label>
                        : ''
                    }
                    {codNegocio === 3 && !debeFirmar ?
                        <div style={{ display: 'block', width: '100%', borderTop: '0px' }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={aceptoCondiciones}
                                        onChange={(e, h) => {
                                            setAcepto(h)
                                        }}
                                        disabled={false}
                                    />
                                }

                                label={<div className="enrollment__subtitle"><b>Términos y Condiciones de la matrícula:</b> usted deberá indicar si acepta las condiciones de la matrícula para finalizar el proceso. revise las condiciones <a style={{ cursor: 'pointer', color: 'blue' }} onClick={() => setOpenCondiciones(true)} target='_blank' rel='noopener'> aquí </a></div>}
                            />
                        </div>
                        :
                        ""
                    }
                </DialogContent>
                <DialogActions>
                    {
                        guardar ?
                            <Button autoFocus
                                disabled={codNegocio === 3 && !debeFirmar ? (aceptoCondiciones ? (formaPagoFP === 1 ? false : (DatosFacturacionGuardados ? false : true)) : true) : false}
                                onClick={() => {
                                    GuardarFormaPago()
                                    setOpenModalFormasPago(false)
                                }} color="primary">
                                Aceptar
                            </Button>
                            :
                            ""
                    }

                    <Button autoFocus onClick={() => {
                        setOpenModalFormasPago(false)
                    }} color="primary" >Salir</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={OpenValidarDatosFacturacion}
                onClose={() => setOpenValidarDatosFacturacion(false)}
                aria-labelledby="draggable-dialog-title"
                maxWidth="lg"
            >
                <DialogTitle>
                    <DialogContent>
                        <DialogContentText style={{ width: 600 }}>
                            <div style={{ fontFamily: 'sans-serif', textAlign: 'center', height: '100%' }}>
                                Para continuar con el proceso de matrícula,favor ingresar los datos de facturación
                            </div>
                        </DialogContentText>
                    </DialogContent>
                </DialogTitle>
                <DialogActions>
                    <Button style={{ width: '4rem', border: '1px solid gray' }} onClick={() => { setOpenValidarDatosFacturacion(false) }}>Cerrar</Button>&nbsp;
                </DialogActions>
            </Dialog>
            {
                openModalToken.open ?
                    <MensajeToken mnsj={openModalToken.mnsj} codNegocio={codNegocio}></MensajeToken>
                    :
                    ""
            }
        </>
    )
}